/* SCKR Customizer v3 (27-09-2026): kopie van customizer-sckr.js met de mobiele
 * bediening uit stap 2 van de impeccable-audit. Alleen onder 1024px anders:
 *   - lade toont één ding tegelijk: gereedschap, lagen of afronden (data-view)
 *   - lagen is een eigen tab, afronden opent via de koopknop rechtsboven
 *   - ⋯-menu voor zoomen, wijzigen, delen, bewaren, pdf en resetten
 *   - het bord schuift en schaalt boven de open lade (liftBoard), zonder
 *     canvas-rebuild: Fabric 6 rekent CSS-transforms zelf om
 *   - geen donkere laag over het ontwerp; omlaag vegen op de greep sluit
 * customizer-sckr.js (v1/v2) blijft ongewijzigd.
 */
/* SCKR Customizer — editor
 *
 * Ontwerpuitgangspunt: het design-JSON in MILLIMETERS is de bron van waarheid,
 * niet de Fabric-canvas. Fabric is puur een bewerkingslaag daarop. Bij elke
 * wijziging schrijven we terug naar millimeters; bij elke resize bouwen we de
 * canvas opnieuw op uit die millimeters. Zo kan wat de klant ziet niet uit de
 * pas lopen met wat er geprint wordt.
 *
 * Event-delegatie op document, geen directe binding: handlers moeten een
 * sectie-herlaad van `shopify theme dev` overleven (zie LEARNINGS.md).
 */
(function () {
  'use strict';

  var PALETTE = [
    '#0a0a0a', '#ffffff', '#00d165', '#f61f35',
    '#1d4ed8', '#f5a524', '#7c3aed', '#e7e7e7'
  ];

  var BASES = [
    { id: 'black', label: 'Zwart', value: '#0a0a0a' },
    { id: 'white', label: 'Wit', value: '#ffffff' }
  ];

  var MATERIALS = [
    { id: 'core', label: 'Core', sub: 'Kunststof' },
    { id: 'carbon', label: 'Carbon', sub: 'Lichter' }
  ];

  var POPULAR = ['nl', 'ma', 'tr', 'sr', 'be', 'de', 'gb-eng', 'es', 'pt', 'it', 'fr', 'br',
    'ar', 'pl', 'cv', 'cw', 'id', 'gh', 'ng', 'dz', 'eg', 'hr', 'rs', 'sn'];

  /* ---------------------------------------------------------- Teksten --
     Alle klantteksten komen uit snippets/customizer-i18n-sckr.liquid, die ze
     met | t uit de locale-bestanden haalt. Bron: customizer/i18n/strings.json,
     opnieuw bouwen met `npm run i18n`. {naam} wordt hier ingevuld. Meldingen
     die alleen in de theme editor verschijnen blijven Nederlands. */
  var STR = null;
  function tx(key, vars) {
    if (!STR) {
      var node = document.querySelector('[data-sckrc-i18n]');
      try { STR = node ? JSON.parse(node.textContent) : {}; } catch (e) { STR = {}; }
    }
    var s = STR[key];
    if (s == null || /^translation missing/i.test(s)) s = key;
    if (vars) s = String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    return s;
  }
  function slug(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '_'); }
  // Vertaling als die er is, anders de tekst uit de data (vormen, categorieën).
  function tOr(key, fallback) { var s = tx(key); return s === key ? fallback : s; }

  /* Landnamen in de taal van de winkel. De catalogus is Nederlands; voor andere
     talen vraagt de browser de naam op bij de tweeletterige landcode. */
  var REGION = null;
  function flagName(flag) {
    var lang = document.documentElement.lang || 'nl';
    if (!/^nl/i.test(lang) && /^[a-z]{2}$/.test(flag.code) && window.Intl && Intl.DisplayNames) {
      try {
        REGION = REGION || new Intl.DisplayNames([lang], { type: 'region' });
        var n = REGION.of(flag.code.toUpperCase());
        if (n && n !== flag.code.toUpperCase()) return n;
      } catch (e) { /* onbekende taal: catalogusnaam */ }
    }
    return flag.name;
  }

  var instances = new WeakMap();

  var ZOOM_STEPS = [0.6, 0.75, 0.9, 1, 1.25, 1.5, 2];
  var HISTORY_MAX = 30;

  /* ------------------------------------------------- Model: twee kanten --
     Spiegelbeeld van customizer/src/design.js. Links en rechts zijn twee
     ontwerpen; staat "beide hetzelfde" aan, dan is rechts een kopie van links
     en wordt hij bij elke wijziging bijgetrokken. */

  function emptySide() {
    return { background: { type: 'color', value: '#0a0a0a' }, elements: [] };
  }

  function emptyDesign() {
    return { version: 2, sameBothSides: true, sides: { left: emptySide(), right: emptySide() } };
  }

  function normalizeDesign(d) {
    if (!d || typeof d !== 'object') return emptyDesign();
    if (d.sides && d.sides.left) {
      return {
        version: 2,
        sameBothSides: d.sameBothSides !== false,
        sides: {
          left: { background: d.sides.left.background || emptySide().background,
                  elements: Array.isArray(d.sides.left.elements) ? d.sides.left.elements : [] },
          right: d.sides.right
            ? { background: d.sides.right.background || emptySide().background,
                elements: Array.isArray(d.sides.right.elements) ? d.sides.right.elements : [] }
            : clone({ background: d.sides.left.background, elements: d.sides.left.elements })
        }
      };
    }
    // v1: een ontwerp dat op beide kanten komt.
    var left = { background: d.background || emptySide().background,
                 elements: Array.isArray(d.elements) ? d.elements : [] };
    return { version: 2, sameBothSides: true, sides: { left: left, right: clone(left) } };
  }

  function clone(v) { return JSON.parse(JSON.stringify(v)); }

  /* ------------------------------------------------------------------ Hulp */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* De iconen staan in de liquid-snippet; voor regels die JS aanmaakt hebben we
     er een paar los nodig. Zelfde raster en lijndikte als de rest. */
  var ICONS = {
    text:   '<path d="M3.5 5V3.5h13V5M10 3.5v13M7 16.5h6"/>',
    upload: '<path d="M10 13.5v-11M6 6.5 10 2.5l4 4M3 13v3.5h14V13"/>',
    assets: '<circle cx="6.25" cy="6.25" r="3.75"/><rect x="10.5" y="10.5" width="7" height="7"/>',
    up:     '<path d="M10 16V4M4.5 9.5 10 4l5.5 5.5"/>',
    down:   '<path d="M10 4v12M4.5 10.5 10 16l5.5-5.5"/>',
    trash:  '<path d="M3.5 5.5h13M8 5.5V3.5h4v2M5.5 5.5l.8 11h7.4l.8-11M8.5 8.5v5M11.5 8.5v5"/>'
  };

  function iconSvg(name) {
    return '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
           'aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  function uid() {
    return 'e' + Math.random().toString(36).slice(2, 9);
  }

  function readableOn(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return '#0a0a0a';
    var n = parseInt(m[1], 16);
    function lin(c) { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    var L = 0.2126 * lin((n >> 16) & 255) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255);
    return L > 0.45 ? '#0a0a0a' : '#ffffff';
  }

  function loadFonts(geo) {
    if (document.getElementById('sckrc-fonts')) return;
    var families = (geo.fonts || []).map(function (f) {
      return 'family=' + encodeURIComponent(f.family).replace(/%20/g, '+');
    });
    if (!families.length) return;
    var link = el('link');
    link.id = 'sckrc-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?' + families.join('&') + '&display=swap';
    document.head.appendChild(link);
  }

  /* Naam waaronder de browser het lettertype kent. De printserver gebruikt de
     id; de browser de Google-familienaam. */
  function familyOf(geo, id) {
    var f = (geo.fonts || []).filter(function (x) { return x.id === id; })[0];
    return f ? f.family : id;
  }

  /* ------------------------------------------------------------- Editor ---- */

  function Editor(root) {
    this.root = root;
    this.geo = window.SCKR_GEOMETRY;
    this.q = function (sel) { return root.querySelector(sel); };

    this.state = {
      size: root.dataset.defaultSize || null,
      material: root.dataset.defaultMaterial || null,
      design: emptyDesign(),
      side: 'left',
      tool: 'base',
      selectedId: null,
      zoom: 1,
      history: [],
      hIndex: -1
    };

    var confirmBtn = this.q('[data-sckrc-confirm]');
    if (confirmBtn) confirmBtn.setAttribute('data-sckrc-label', confirmBtn.textContent.trim());

    this.restore();
    this.buildSetup();
    this.bind();
    var rights = this.q('[data-sckrc-rights]');
    if (rights) rights.addEventListener('change', function () {
      rights.closest('.sckrc__rights').removeAttribute('data-invalid');
    });
    this.syncTop();

    var params = new URLSearchParams(window.location.search);

    // Deellink: /pagina?d=CODE opent het bewaarde ontwerp van iemand anders,
    // of je eigen ontwerp op een ander apparaat.
    var shared = params.get('d');
    if (shared) { this.loadShared(shared.trim().toUpperCase()); return; }

    /* Vanaf de productpagina komen maat en materiaal mee. Alleen overnemen als
       er nog geen ontwerp in de maak is — anders zou een klik vanaf een andere
       productpagina stilletjes iemands werk omgooien. */
    var bezig = (this.state.design.sides.left.elements || []).length +
                (this.state.design.sides.right.elements || []).length;
    // Materiaal verandert de vorm niet, dus dat mag de PDP altijd bepalen.
    var m = (params.get('m') || '').toLowerCase();
    if (m === 'core' || m === 'carbon') this.state.material = m;
    if (!bezig) {
      var size = this.sizeFromParam(params.get('s'));
      if (size) this.state.size = size;
    }
    // Staat die combinatie niet op voorraad, dan eerst het andere materiaal in
    // dezelfde maat, en pas daarna een andere maat (alleen zonder ontwerp in
    // de maak: een andere maat verschuift de vorm onder iemands werk).
    this.preferAvailable(!!bezig);
    this.buildSetup();

    if (this.state.size && this.state.material) this.enterWork();
    else this.showSetup();
  }

  /* "12 cm", "12cm", "12" of "12CM" moeten allemaal op dezelfde maat uitkomen:
     de schrijfwijze in Shopify staat los van onze sjabloonnamen. */
  Editor.prototype.sizeFromParam = function (raw) {
    if (!raw) return null;
    var key = String(raw).toLowerCase().replace(/[^0-9a-z]/g, '');
    var sizes = this.geo.sizes || [];
    for (var i = 0; i < sizes.length; i++) {
      var id = sizes[i];
      var label = (this.geo.templates[id].label || '').toLowerCase().replace(/[^0-9a-z]/g, '');
      if (key === id || key === label) return id;
    }
    // Alleen een getal ("12") mag ook, mits het maar op één maat kan slaan.
    var num = key.replace(/[^0-9]/g, '');
    if (num) {
      var hits = sizes.filter(function (id) { return id.replace(/[^0-9]/g, '') === num; });
      if (hits.length === 1) return hits[0];
    }
    return null;
  };

  /* Een bewaarde code openen. Bestaand werk wordt niet zomaar overschreven:
     dat is dezelfde afspraak als bij het vinkje "beide hetzelfde" uitzetten. */
  Editor.prototype.openByCode = function () {
    var input = this.q('[data-sckrc-codeinput]');
    var status = this.q('[data-sckrc-codestatus]');
    var code = (input.value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

    function melden(tekst, soort) {
      if (!status) return;
      status.textContent = tekst || '';
      status.setAttribute('data-kind', soort || '');
    }

    if (code.length < 8) { melden(tx('code_invalid'), 'error'); return; }

    var bezig = (this.state.design.sides.left.elements || []).length +
                (this.state.design.sides.right.elements || []).length;
    if (bezig && !window.confirm(tx('confirm_lose'))) return;

    melden(tx('opening'), '');
    var self = this;
    this.loadShared(code, function (fout) {
      melden(fout || '', fout ? 'error' : '');
      if (!fout) input.value = '';
    });
  };

  Editor.prototype.loadShared = function (code, done) {
    var self = this;
    this.showSetup();
    this.rpc('get_design', { p_short_code: code }).then(function (rows) {
      var row = Array.isArray(rows) ? rows[0] : rows;
      if (!row || !row.data) throw new Error(tx('code_missing', { code: code }));
      self.state.size = row.size;
      self.state.material = row.material || self.state.material;
      self.state.design = normalizeDesign(row.data);
      // Zonder bewerk-token is dit een kopie: opslaan maakt straks een nieuw
      // ontwerp aan in plaats van dat van iemand anders te overschrijven.
      self.state.saved = null;
      self.state.history = [];
      self.state.hIndex = -1;
      self.buildSetup();
      self.enterWork();
      self.toast(tx('opened_copy', { code: code }), 'ok');
      if (done) done(null);
    }).catch(function (e) {
      self.toast(e.message, 'error');
      self.showSetup();
      if (done) done(e.message);
    });
  };

  Editor.prototype.flagUrl = function (code) {
    var base = (this.root.dataset.supabaseUrl || '').replace(/\/$/, '');
    return base + (this.geo.flagPath || '/storage/v1/object/public/assets/flags/') + code + '.svg';
  };

  /* Haalt een vlag op en geeft hem een eigen afmeting mee.
     De bronbestanden hebben alleen een viewBox. Een SVG zonder width/height
     heeft in een <img> geen intrinsieke maat, waarop de browser terugvalt op
     300x150 — dus 2:1 in plaats van 4:3. De vlag werd daardoor uitgerekt en
     viel deels buiten de scheenbeschermer.
     We zetten de maten uit de viewBox er alsnog in en leveren het geheel als
     data-URI: geen cross-origin gedoe en de verhouding klopt gegarandeerd. */
  Editor.prototype.loadFlag = function (code) {
    var self = this;
    this._flags = this._flags || {};
    if (this._flags[code]) return Promise.resolve(this._flags[code]);

    return fetch(this.flagUrl(code)).then(function (res) {
      if (!res.ok) throw new Error(tx('flag_failed', { code: code }));
      return res.text();
    }).then(function (svg) {
      var vb = /viewBox="([^"]+)"/.exec(svg);
      var parts = vb ? vb[1].trim().split(/[\s,]+/).map(Number) : [0, 0, 640, 480];
      var w = parts[2] || 640;
      var h = parts[3] || 480;
      var sized = /<svg[^>]*\swidth=/.test(svg)
        ? svg
        : svg.replace(/<svg\b/, '<svg width="' + w + '" height="' + h + '"');
      var out = {
        aspect: w / h,
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(sized)
      };
      self._flags[code] = out;
      return out;
    });
  };

  /* De kant waar je nu aan werkt. Alle gereedschappen praten hiertegen in
     plaats van tegen het ontwerp als geheel. */
  Editor.prototype.side = function () {
    return this.state.design.sides[this.state.side] || this.state.design.sides.left;
  };

  /* Houdt rechts gelijk aan links zolang het vinkje aan staat. */
  Editor.prototype.syncSides = function () {
    var d = this.state.design;
    if (d.sameBothSides) d.sides.right = clone(d.sides.left);
  };

  /* ------------------------------------------------------- Geschiedenis --
     We bewaren hele momentopnamen van het ontwerp, niet losse handelingen.
     Bij een ontwerp van een paar kilobyte is dat verwaarloosbaar, en het kan
     niet uit de pas lopen zoals een omkeer-per-handeling dat wel kan. */

  Editor.prototype.pushHistorySoon = function () {
    var self = this;
    clearTimeout(this._histTimer);
    this._histTimer = setTimeout(function () { self.pushHistory(); }, 500);
  };

  Editor.prototype.pushHistory = function () {
    var snap = JSON.stringify(this.state.design);
    if (this.state.history[this.state.hIndex] === snap) return;
    this.state.history = this.state.history.slice(0, this.state.hIndex + 1);
    this.state.history.push(snap);
    if (this.state.history.length > HISTORY_MAX) this.state.history.shift();
    this.state.hIndex = this.state.history.length - 1;
    this.syncHistoryButtons();
  };

  Editor.prototype.applyHistory = function (i) {
    if (i < 0 || i >= this.state.history.length) return;
    this.state.hIndex = i;
    this.state.design = normalizeDesign(JSON.parse(this.state.history[i]));
    this.state.selectedId = null;
    this.paint();
    this.renderTab();
    this.renderLayers();
    this.renderSideThumbs();
    this.syncHistoryButtons();
    this.persist();
  };

  Editor.prototype.undo = function () { this.applyHistory(this.state.hIndex - 1); };
  Editor.prototype.redo = function () { this.applyHistory(this.state.hIndex + 1); };

  Editor.prototype.syncHistoryButtons = function () {
    var u = this.q('[data-sckrc-undo]');
    var r = this.q('[data-sckrc-redo]');
    if (u) u.disabled = this.state.hIndex <= 0;
    if (r) r.disabled = this.state.hIndex >= this.state.history.length - 1;
  };

  /* ------------------------------------------------------------- Zoom ---- */

  Editor.prototype.zoomBy = function (dir) {
    var i = ZOOM_STEPS.indexOf(this.state.zoom);
    if (i < 0) i = ZOOM_STEPS.indexOf(1);
    i = Math.max(0, Math.min(ZOOM_STEPS.length - 1, i + (dir === 'in' ? 1 : -1)));
    this.state.zoom = ZOOM_STEPS[i];
    this.root.style.setProperty('--sckrc-zoom', this.state.zoom);
  };

  Editor.prototype.resetAll = function () {
    if (!window.confirm(tx('confirm_reset'))) return;
    this.state.design = emptyDesign();
    this.state.selectedId = null;
    this.state.zoom = 1;
    this.root.style.setProperty('--sckrc-zoom', 1);
    this.pushHistory();
    this.paint();
    this.renderTab();
    this.renderLayers();
    this.renderSideThumbs();
    this.persist();
    this.toast(tx('cleared'), 'ok');
  };

  Editor.prototype.tpl = function () {
    return this.geo.templates[this.state.size];
  };

  /* Afstand tot de viewporttop meten in plaats van de headerhoogte raden.
     Werkt ongeacht welke header actief is. */
  Editor.prototype.syncTop = function () {
    var top = Math.max(0, Math.round(this.root.getBoundingClientRect().top + window.scrollY));
    this.root.style.setProperty('--sckrc-top', top + 'px');
  };

  /* ---------------------------------------------------------------- Opslag */

  Editor.prototype.storageKey = function () { return 'sckrc:draft:v1'; };

  Editor.prototype.persist = function () {
    // Eén plek waar alles samenkomt: rechts bijtrekken als "beide hetzelfde"
    // aan staat, en de miniaturen verversen.
    this.syncSides();
    this.updateThumb();
    try {
      localStorage.setItem(this.storageKey(), JSON.stringify({
        size: this.state.size, material: this.state.material,
        design: this.state.design, saved: this.state.saved || null
      }));
    } catch (e) { /* privémodus of vol: niet fataal */ }
  };

  Editor.prototype.restore = function () {
    try {
      var raw = localStorage.getItem(this.storageKey());
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d && d.size && this.geo.templates[d.size]) {
        this.state.size = d.size;
        this.state.material = d.material || this.state.material;
        if (d.design) this.state.design = normalizeDesign(d.design);
        if (d.saved && d.saved.code) this.state.saved = d.saved;
      }
    } catch (e) { /* onleesbaar concept negeren */ }
  };

  /* ----------------------------------------------------------------- Setup */

  Editor.prototype.buildSetup = function () {
    var self = this;
    var sizes = this.q('[data-sckrc-sizes]');
    var mats = this.q('[data-sckrc-materials]');
    sizes.innerHTML = '';
    mats.innerHTML = '';
    mats.setAttribute('data-cols', '2');

    this.geo.sizes.forEach(function (id) {
      var t = self.geo.templates[id];
      var b = el('button', 'sckrc__opt');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-sckrc-size', id);
      b.setAttribute('aria-checked', String(self.state.size === id));
      var anyMat = MATERIALS.some(function (m) { return self.isAvailable(id, m.id); });
      b.appendChild(el('span', null, t.label));
      b.appendChild(el('span', 'sckrc__optsub', anyMat
        ? t.shapeMm.w.toFixed(0) + '×' + t.shapeMm.h.toFixed(0) + ' mm'
        : tx('sold_out')));
      if (!anyMat) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      sizes.appendChild(b);
    });

    MATERIALS.forEach(function (m) {
      var b = el('button', 'sckrc__opt');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-sckrc-material', m.id);
      b.setAttribute('aria-checked', String(self.state.material === m.id));
      var ok = !self.state.size || self.isAvailable(self.state.size, m.id);
      b.appendChild(el('span', null, m.label));
      b.appendChild(el('span', 'sckrc__optsub', ok ? tx('mat_' + m.id + '_sub') : tx('sold_out')));
      if (!ok) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      mats.appendChild(b);
    });

    this.q('[data-sckrc-step-material]').hidden = !this.state.size;

    var confirm = this.q('[data-sckrc-confirm]');
    var ready = Boolean(this.state.size && this.state.material);
    confirm.disabled = !ready;
    confirm.textContent = ready
      ? confirm.getAttribute('data-sckrc-label') || confirm.textContent
      : tx('choose_first');
  };

  /* Is deze maat in dit materiaal te bestellen als Custom? Zonder productdata
     (nog niet gekoppeld in de theme editor) blokkeren we niets. */
  Editor.prototype.isAvailable = function (size, material) {
    var all = this.products();
    var p = all && all[material];
    if (!all) return true;
    if (!p || !p.variants) return false;
    var t = this.geo.templates[size];
    if (!t) return false;
    var r = pickVariant(p.variants, t.label, this.root.dataset.customOption, material);
    return !!(r.variant && r.available);
  };

  Editor.prototype.preferAvailable = function (sizeLocked) {
    var self = this;
    var mats = MATERIALS.map(function (x) { return x.id; });
    var size = this.state.size, mat = this.state.material;
    if (size && mat && this.isAvailable(size, mat)) return;

    var otherMats = mats.filter(function (x) { return x !== mat; });
    var tries = [];
    if (size) {
      if (mat) tries.push([size, mat]);
      otherMats.forEach(function (x) { tries.push([size, x]); });
    }
    if (!sizeLocked) {
      this.geo.sizes.forEach(function (sz) {
        if (sz === size) return;
        if (mat) tries.push([sz, mat]);
        otherMats.forEach(function (x) { tries.push([sz, x]); });
      });
    }
    for (var i = 0; i < tries.length; i++) {
      if (self.isAvailable(tries[i][0], tries[i][1])) {
        // Zonder gekozen maat alleen het materiaal invullen: de klant kiest zelf.
        if (size || sizeLocked) this.state.size = tries[i][0];
        this.state.material = tries[i][1];
        return;
      }
    }
  };

  Editor.prototype.showSetup = function () {
    this.q('[data-sckrc-panel]').setAttribute('data-state', 'setup');
    this.q('[data-sckrc-setup]').hidden = false;
    this.q('[data-sckrc-work]').hidden = true;
    this.q('[data-sckrc-board]').hidden = !this.state.size;
    this.q('[data-sckrc-summary]').hidden = true;
    var sidesOff = this.q('[data-sckrc-sides]');
    if (sidesOff) sidesOff.hidden = true;
    this.q('[data-sckrc-submit]').disabled = true;
    var coOff = this.q('[data-sckrc-checkout]');
    if (coOff) coOff.disabled = true;
    this.toggleMenu(false);
    this.syncSheet();
    if (this.state.size) this.renderBoard();
  };

  Editor.prototype.enterWork = function () {
    this.q('[data-sckrc-panel]').setAttribute('data-state', 'work');
    this.openSheet(false);
    this.q('[data-sckrc-setup]').hidden = true;
    this.q('[data-sckrc-work]').hidden = false;
    this.q('[data-sckrc-board]').hidden = false;
    this.q('[data-sckrc-summary]').hidden = false;
    var sides = this.q('[data-sckrc-sides]');
    if (sides) sides.hidden = false;
    this.q('[data-sckrc-submit]').disabled = false;
    var m = MATERIALS.filter(function (x) { return x.id === this.state.material; }, this)[0];
    this.q('[data-sckrc-summary-text]').textContent =
      this.tpl().label + ' \u00b7 ' + (m ? m.label : '—');
    var coOn = this.q('[data-sckrc-checkout]');
    if (coOn) coOn.disabled = false;
    var coSum = this.q('[data-sckrc-checkout-summary]');
    if (coSum) coSum.textContent = this.tpl().label + ' \u00b7 ' + (m ? m.label : '—');
    this.syncSheet();
    this.renderBoard();
    this.renderTab();
    this.renderLayers();
    this.renderSideThumbs();
    this.updatePrice();
    if (this.state.hIndex < 0) this.pushHistory();
    this.persist();
  };

  /* Zet de prijs in de knop en de opbouw eronder. De meerprijs komt uit het
     verschil tussen de Standaard- en de Custom-variant, dus de klant ziet
     altijd het bedrag dat in de admin staat. */
  Editor.prototype.updatePrice = function () {
    var btn = this.q('[data-sckrc-submit]');
    var label = btn.getAttribute('data-sckrc-label') ||
                (btn.setAttribute('data-sckrc-label', btn.textContent.trim()), btn.textContent.trim());

    var match = this.product() ? this.matchVariant() : null;
    btn.textContent = (!match || match.problem || !match.variant)
      ? label
      : label + ' \u00b7 ' + money(match.variant.price);
    var buy = this.q('[data-sckrc-buyprice]');
    if (buy) buy.textContent = (!match || match.problem || !match.variant) ? '' : money(match.variant.price);
    // De opbouw (basis + meerprijs) staat bij de bestelregel in de winkelwagen.
  };

  /* Vertelt het werkvlak hoe hoog de bottom sheet werkelijk is, zodat het bord
     erboven past in plaats van eronder te verdwijnen. Zonder dit is de
     scheenbeschermer niet te zien terwijl je tekst bewerkt. */
  Editor.prototype.syncSheet = function () {
    if (!window.matchMedia('(max-width: 1023px)').matches) {
      this.root.style.removeProperty('--sckrc-sheet-h');
      this.root.style.removeProperty('--sckrc-sheet-shut');
      return;
    }

    /* Hoogte van de dichte sheet meten in plaats van vastzetten: hij moet de
       gereedschapsbalk en de koopknop tonen, en die hoogte verandert mee met
       de knoppen erin. Stond dit te laag, dan viel de koopknop buiten beeld. */
    var tools = this.root.querySelector('.sckrc__tools');
    var foot = this.root.querySelector('.sckrc__foot');
    if (tools && foot) {
      var shut = tools.offsetHeight + foot.offsetHeight;
      if (shut > 0) this.root.style.setProperty('--sckrc-sheet-shut', Math.round(shut) + 'px');
    }
    var panel = this.q('[data-sckrc-panel]');
    var open = panel.getAttribute('data-open') === 'true' ||
               panel.getAttribute('data-state') === 'setup';
    var h = open ? panel.offsetHeight : parseInt(getComputedStyle(this.root)
      .getPropertyValue('--sckrc-toolbar-h'), 10) || 64;
    this.root.style.setProperty('--sckrc-sheet-h', Math.round(h) + 'px');
    this.liftBoard(open);
  };

  /* Het bord boven de open lade houden. Verschuiven en verkleinen met een
     transform, niet met een kleiner vak: een andere maat laat de ResizeObserver
     het canvas opnieuw opbouwen, en dan raakt de selectie kwijt terwijl je typt.
     Fabric 6 meet de aanraking via getBoundingClientRect, dus een transform
     klopt gewoon. Alle maten hier komen uit de layout (offsetTop/-Height), die
     een transform niet ziet: zo meten we nooit onze eigen verschuiving. */
  Editor.prototype.liftBoard = function (open) {
    var wrap = this.q('.sckrc__boardwrap');
    var stage = this.q('.sckrc__stage');
    var panel = this.q('[data-sckrc-panel]');
    if (!wrap || !stage || !panel) return;
    if (!open || !window.matchMedia('(max-width: 1023px)').matches || !wrap.offsetHeight) {
      wrap.style.removeProperty('transform');
      return;
    }
    var top = stage.getBoundingClientRect().top + wrap.offsetTop;
    var bottom = window.innerHeight - panel.offsetHeight - 8;
    var area = bottom - top;
    var board = this.q('[data-sckrc-board]');
    var bh = (board && board.offsetHeight) || wrap.offsetHeight;
    var scale = Math.max(0.3, Math.min(1, area / bh));
    var dy = (top + area / 2) - (top + wrap.offsetHeight / 2);
    wrap.style.transform = 'translateY(' + Math.round(dy) + 'px) scale(' + scale.toFixed(3) + ')';
  };

  /* ⋯-menu in de bovenbalk (mobiel). Zonder argument wisselen. */
  Editor.prototype.toggleMenu = function (open) {
    var menu = this.q('[data-sckrc-menu]');
    var btn = this.q('[data-sckrc-more]');
    if (!menu) return;
    if (open === undefined) open = menu.hidden;
    menu.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (open) {
      var first = menu.querySelector('button');
      if (first) first.focus();
    }
  };

  /* ------------------------------------------------------------ Werkvlak -- */

  Editor.prototype.renderBoard = function () {
    var t = this.tpl();
    if (!t) return;
    var board = this.q('[data-sckrc-board]');
    board.style.setProperty('--sckrc-ar', (t.artboardMm.w / t.artboardMm.h).toFixed(5));

    // Wachten tot de layout de definitieve maat heeft, anders meten we 0.
    var self = this;
    requestAnimationFrame(function () { self.paint(); });
  };

  Editor.prototype.paint = function () {
    var t = this.tpl();
    var board = this.q('[data-sckrc-board]');
    var w = board.clientWidth;
    var h = board.clientHeight;
    if (!w || !h) return;

    this.scale = w / t.artboardMm.w;          // px per mm
    var bg = this.side().background.value;

    // Achtergrondlaag: het hele printvlak (contour plus bleed) in de gekozen
    // kleur. Wat de klant hier ziet, is precies wat er gedrukt wordt.
    var vb = '0 0 ' + t.artboardMm.w + ' ' + t.artboardMm.h;
    this.q('[data-sckrc-bg]').setAttribute('viewBox', vb);
    this.q('[data-sckrc-bg]').innerHTML = this.printZone(t, bg);

    // Voorgrondlaag: de snijrand zacht afgedekt, de snijlijn, en de vaste
    // logopositie. De rand valt na het snijden weg; de sluier laat dat zien
    // zonder het bord druk te maken.
    var line = readableOn(bg);
    var logo = this.logoMarkup(t, line);
    var mid = 'sckrc-cut-' + (this._uid || (this._uid = Math.random().toString(36).slice(2, 8)));
    this.q('[data-sckrc-fg]').setAttribute('viewBox', vb);
    this.q('[data-sckrc-fg]').innerHTML =
      '<mask id="' + mid + '" maskUnits="userSpaceOnUse" x="0" y="0" width="' + t.artboardMm.w + '" height="' + t.artboardMm.h + '">' +
        this.printZone(t, '#fff') +
        '<path d="' + t.contour + '" fill="#000"/>' +
      '</mask>' +
      '<rect class="sckrc__cutveil" width="100%" height="100%" mask="url(#' + mid + ')"/>' +
      '<path d="' + t.contour + '" fill="none" stroke="' + line + '" stroke-opacity="0.25" stroke-width="0.3"/>' +
      logo +
      '<g class="sckrc__guides" data-sckrc-guides></g>';
    this.guideNode = this.q('[data-sckrc-guides]');

    this.buildCanvas(w, h);
  };

  /* Het printvlak: de contour uitgezet met de bleed. Zelfde truc als de
     renderer (src/render.js): een stroke van 2x de bleed groeit precies één
     bleed naar buiten, met ronde hoeken. */
  Editor.prototype.printZone = function (t, colour) {
    return '<path d="' + t.contour + '" fill="' + colour + '" stroke="' + colour + '" ' +
      'stroke-width="' + (2 * t.bleedMm.x) + '" stroke-linejoin="round" stroke-linecap="round"/>';
  };

  /* Het logo staat vast en wordt server-side opnieuw geplaatst; hier tonen we
     alleen wáár het komt, buiten het bereik van de klant. */
  Editor.prototype.logoMarkup = function (t, colour) {
    var L = this.geo.logo;
    var s = t.logo.wMm;
    var g = '<g fill="' + colour + '" transform="translate(' + t.logo.xMm + ' ' + t.logo.yMm + ') scale(' + s + ')">';
    for (var i = 0; i < L.paths.length; i++) g += '<path d="' + L.paths[i] + '"/>';
    return g + '</g>';
  };

  Editor.prototype.buildCanvas = function (w, h) {
    var self = this;
    var t = this.tpl();
    var elCanvas = this.q('[data-sckrc-canvas]');

    if (this.canvas) { this.canvas.dispose(); this.canvas = null; }

    /* v3: het canvas steekt CANVAS_PAD px buiten het bord uit, zodat handvatten
       van een element aan de rand nog te pakken zijn. Het ontwerp blijft in
       dezelfde coördinaten: de viewport schuift gewoon PAD op. */
    var PAD = this.CANVAS_PAD;
    this.canvas = new fabric.Canvas(elCanvas, {
      width: w + 2 * PAD,
      height: h + 2 * PAD,
      backgroundColor: 'transparent',
      preserveObjectStacking: true,
      selection: false,
      controlsAboveOverlay: true
    });

    // Elementen zijn zichtbaar tot de rand van het printvlak, niet verder.
    // Een Fabric-clipPath negeert strokes, dus het printvlak kan daar niet in;
    // een CSS-masker op de tekenlaag wel. De handvatten staan op de bovenste
    // laag en blijven daardoor ook buiten het vlak te pakken.
    var mask = 'url("data:image/svg+xml,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + t.artboardMm.w + ' ' + t.artboardMm.h +
      '" preserveAspectRatio="none">' + this.printZone(t, '#000') + '</svg>') + '")';
    var lower = this.canvas.lowerCanvasEl.style;
    ['maskImage', 'webkitMaskImage'].forEach(function (p) { lower[p] = mask; });
    ['maskSize', 'webkitMaskSize'].forEach(function (p) { lower[p] = w + 'px ' + h + 'px'; });
    ['maskPosition', 'webkitMaskPosition'].forEach(function (p) { lower[p] = PAD + 'px ' + PAD + 'px'; });
    ['maskRepeat', 'webkitMaskRepeat'].forEach(function (p) { lower[p] = 'no-repeat'; });
    this.canvas.setViewportTransform([1, 0, 0, 1, PAD, PAD]);
    this.canvas.wrapperEl.classList.add('sckrc__canvaswrap');
    this.canvas.wrapperEl.style.setProperty('--sckrc-canvas-pad', PAD + 'px');

    this.canvas.on('mouse:down', function () { self._dragged = false; });
    this.canvas.on('object:moving', function (e) { self._dragged = true; self.onMoving(e.target); self.trackTrash(e); });
    this.canvas.on('mouse:up', function (e) { self.dropTrash(e); });
    this.canvas.on('object:scaling', function () { self._dragged = true; });
    this.canvas.on('object:rotating', function () { self._dragged = true; });
    this.canvas.on('mouse:up', function (e) { self.onTap(e); });
    this.canvas.on('object:modified', function (e) { self.readBack(e.target); self.clearGuides(); });
    this.canvas.on('mouse:up', function () { self.clearGuides(); });
    this.canvas.on('selection:created', function (e) { self.onSelect(e); });
    this.canvas.on('selection:updated', function (e) { self.onSelect(e); });
    this.canvas.on('selection:cleared', function () { self.state.selectedId = null; self.renderTab(); });

    this.side().elements
      .slice()
      .sort(function (a, b) { return (a.z || 0) - (b.z || 0); })
      .forEach(function (item) { self.addToCanvas(item); });

    this.canvas.requestRenderAll();
  };

  /* Magnetisch uitlijnen. Bewust zwak: 7px aantrekking, alleen op middenlijnen
     en op de middens van andere elementen. Je moet vrij kunnen plaatsen; dit
     helpt alleen bij het laatste stukje. */
  Editor.prototype.SNAP_PX = 7;
  Editor.prototype.CANVAS_PAD = 32;

  /* ------------------------------------------------ Sleep naar prullenbak --
     Tijdens het slepen van een element verschijnt onderin een prullenbak.
     Laat je het daar los, dan is het weg (één stap terug haalt het terug). */
  function clientPoint(ev) {
    if (!ev) return null;
    var tt = (ev.changedTouches && ev.changedTouches[0]) || (ev.touches && ev.touches[0]);
    if (tt) return { x: tt.clientX, y: tt.clientY };
    return typeof ev.clientX === 'number' ? { x: ev.clientX, y: ev.clientY } : null;
  }

  Editor.prototype.trashHit = function (ev) {
    var bin = this.q('[data-sckrc-trash]');
    var pt = clientPoint(ev);
    if (!bin || !pt) return false;
    var r = bin.getBoundingClientRect();
    var grow = 16;   // ruim raken: je vinger dekt het doel af
    return pt.x >= r.left - grow && pt.x <= r.right + grow && pt.y >= r.top - grow && pt.y <= r.bottom + grow;
  };

  Editor.prototype.trackTrash = function (e) {
    var bin = this.q('[data-sckrc-trash]');
    if (!bin) return;
    bin.setAttribute('data-show', 'true');
    this._trashHot = this.trashHit(e && e.e);
    bin.setAttribute('data-hot', String(this._trashHot));
    if (e && e.target) e.target.set('opacity', this._trashHot ? 0.4 : 1);
  };

  Editor.prototype.dropTrash = function (e) {
    var bin = this.q('[data-sckrc-trash]');
    if (!bin || bin.getAttribute('data-show') !== 'true') return;
    var hot = this._trashHot;
    this._trashHot = false;
    bin.setAttribute('data-show', 'false');
    bin.setAttribute('data-hot', 'false');
    var obj = e && e.target;
    if (obj) obj.set('opacity', 1);
    if (hot && obj && obj.sckrId) {
      this.state.selectedId = obj.sckrId;
      this.remove();
      if (window.matchMedia('(max-width: 1023px)').matches) this.openSheet(false);
    }
  };

  Editor.prototype.onMoving = function (obj) {
    if (!obj) return;
    var s = this.scale;
    var t = this.tpl();
    var TH = this.SNAP_PX;

    var vs = [t.artboardMm.w / 2 * s];
    var hs = [t.artboardMm.h / 2 * s];
    this.canvas.getObjects().forEach(function (o) {
      if (o === obj || !o.sckrId) return;
      vs.push(o.left);
      hs.push(o.top);
    });

    var bestV = null, bestH = null;
    vs.forEach(function (x) {
      var d = Math.abs(obj.left - x);
      if (d < TH && (!bestV || d < bestV.d)) bestV = { p: x, d: d };
    });
    hs.forEach(function (y) {
      var d = Math.abs(obj.top - y);
      if (d < TH && (!bestH || d < bestH.d)) bestH = { p: y, d: d };
    });

    var guides = [];
    if (bestV) { obj.set('left', bestV.p); guides.push({ dir: 'v', p: bestV.p }); }
    if (bestH) { obj.set('top', bestH.p); guides.push({ dir: 'h', p: bestH.p }); }
    this.drawGuides(guides);
  };

  Editor.prototype.drawGuides = function (guides) {
    if (!this.guideNode) return;
    var t = this.tpl(), s = this.scale, out = '';
    for (var i = 0; i < guides.length; i++) {
      var g = guides[i], mm = g.p / s;
      out += g.dir === 'v'
        ? '<line x1="' + mm + '" y1="0" x2="' + mm + '" y2="' + t.artboardMm.h + '"/>'
        : '<line x1="0" y1="' + mm + '" x2="' + t.artboardMm.w + '" y2="' + mm + '"/>';
    }
    this.guideNode.innerHTML = out;
  };

  Editor.prototype.clearGuides = function () {
    if (this.guideNode) this.guideNode.innerHTML = '';
  };

  /* Tikken zonder slepen op een element dat al geselecteerd is, opent de
     instellingen. Zo blijft slepen slepen en hoef je niet naar de balk. */
  Editor.prototype.onTap = function (e) {
    var obj = e && e.target;
    if (this._dragged || !obj || !obj.sckrId) return;
    if (obj.sckrId !== this._lastTapped) { this._lastTapped = obj.sckrId; return; }
    if (window.matchMedia('(max-width: 1023px)').matches) this.openSheet(true, 'tools');
  };

  Editor.prototype.styleObject = function (obj) {
    var handle = getComputedStyle(this.root).getPropertyValue('--sckrc-handle').trim() || '#00d165';
    obj.set({
      borderColor: handle,
      cornerColor: '#ffffff',
      cornerStrokeColor: handle,
      cornerStyle: 'circle',
      cornerSize: 14,
      transparentCorners: false,
      borderScaleFactor: 1.5,
      padding: 2
    });
    /* Touch (v3): grotere, beter zichtbare handvatten en een raakvlak van 44px.
       Fabric gebruikt touchCornerSize alleen bij aanraking, dus desktop blijft 14. */
    if (window.matchMedia('(pointer: coarse)').matches) {
      obj.set({ cornerSize: 20, touchCornerSize: 44, padding: 8 });
    }
  };

  Editor.prototype.addToCanvas = function (item) {
    var s = this.scale;
    var obj = null;

    if (item.type === 'text') {
      /* fabric.Text en niet Textbox: een Textbox houdt zijn ingestelde breedte
         vast, ook bij vier letters. Het selectiekader was dan veel breder dan
         de tekst zelf en centreren werd giswerk. Text meet zich op de inhoud. */
      obj = new fabric.Text(item.text, {
        left: item.xMm * s,
        top: (item.yMm + (item.sizeMm * 0.5)) * s,
        fontSize: item.sizeMm * s,
        fontFamily: familyOf(this.geo, item.font),
        fill: item.fill,
        angle: item.rotation || 0,
        originX: 'center',
        originY: 'center',
        textAlign: 'center',
        charSpacing: item.sizeMm ? ((item.letterSpacingMm || 0) / item.sizeMm) * 1000 : 0
      });
    }

    if (item.type === 'shape') {
      var shape = (this.geo.shapes || []).filter(function (x) { return x.id === item.shapeId; })[0];
      if (!shape) return;
      var vb = this.geo.shapeViewBox || 100;
      obj = new fabric.Path(shape.d, {
        left: (item.xMm + item.widthMm / 2) * s,
        top: (item.yMm + (item.heightMm || item.widthMm) / 2) * s,
        originX: 'center',
        originY: 'center',
        fill: item.fill,
        angle: item.rotation || 0,
        scaleX: (item.widthMm * s) / vb,
        scaleY: ((item.heightMm || item.widthMm) * s) / vb,
        objectCaching: false
      });
    }

    if (item.type === 'flag') {
      var selfF = this;
      var canvasAtStart = this.canvas;
      this.loadFlag(item.flagCode).then(function (flag) {
        return fabric.FabricImage.fromURL(flag.url);
      }).then(function (img) {
        img.set({
          left: (item.xMm + item.widthMm / 2) * s,
          top: (item.yMm + item.heightMm / 2) * s,
          originX: 'center', originY: 'center',
          angle: item.rotation || 0,
          scaleX: (item.widthMm * s) / img.width,
          scaleY: (item.heightMm * s) / img.height
        });
        img.sckrId = item.id;
        img.lockScalingFlip = true;
        selfF.styleObject(img);
        // Tussen laden en plaatsen kan de canvas herbouwd zijn (resize).
        selfF.placeLoaded(img, item, canvasAtStart);
      }).catch(function (e) {
        selfF.status(e.message, 'error');
      });
      return;
    }

    if (item.type === 'image') {
      // Op het canvas tonen we de verkleinde voorbeeldversie; het origineel op
      // volle resolutie staat in Supabase en gaat naar het drukwerk.
      var self = this;
      var canvasAtImg = this.canvas;
      fabric.FabricImage.fromURL(item.preview, { crossOrigin: 'anonymous' }).then(function (img) {
        img.set({
          left: (item.xMm + item.widthMm / 2) * s,
          top: (item.yMm + item.heightMm / 2) * s,
          originX: 'center',
          originY: 'center',
          angle: item.rotation || 0,
          scaleX: (item.widthMm * s) / img.width,
          scaleY: (item.heightMm * s) / img.height
        });
        img.sckrId = item.id;
        img.lockScalingFlip = true;
        self.styleObject(img);
        self.placeLoaded(img, item, canvasAtImg);
      });
      return;
    }

    if (!obj) return;
    obj.sckrId = item.id;
    obj.lockScalingFlip = true;
    this.styleObject(obj);
    this.canvas.add(obj);
    this.restack();
  };

  /* Zet de objecten op het canvas in de volgorde van z. Afbeeldingen en vlaggen
     laden asynchroon en kwamen daardoor altijd bovenop te liggen, wat de
     lagenlijst ook zei. Na elke toevoeging en elke verschuiving draait dit. */
  Editor.prototype.restack = function () {
    var self = this;
    if (!this.canvas) return;
    var z = {};
    (this.side().elements || []).forEach(function (e) { z[e.id] = e.z || 0; });
    this.canvas.getObjects()
      .filter(function (o) { return o.sckrId; })
      .sort(function (a, b) { return (z[a.sckrId] || 0) - (z[b.sckrId] || 0); })
      .forEach(function (o, i) { self.canvas.moveObjectTo(o, i); });
    this.canvas.requestRenderAll();
  };

  /* Een asynchroon geladen beeld alleen plaatsen als het nog klopt: dezelfde
     canvas, het element bestaat nog, en het staat er niet al. */
  Editor.prototype.placeLoaded = function (img, item, canvasAtStart) {
    if (this.canvas !== canvasAtStart) return;
    if (!this.find(item.id)) return;
    if (this.canvas.getObjects().some(function (o) { return o.sckrId === item.id; })) return;
    this.canvas.add(img);
    this.restack();
  };

  Editor.prototype.find = function (id) {
    return this.side().elements.filter(function (e) { return e.id === id; })[0] || null;
  };

  Editor.prototype.onSelect = function (e) {
    var obj = (e.selected && e.selected[0]) || e.target;
    this.state.selectedId = obj ? obj.sckrId : null;
    this._lastTapped = this.state.selectedId;
    if (this.state.selectedId) {
      var picked = this.find(this.state.selectedId);
      this.state.tool = picked
        ? ({ text: 'text', image: 'upload', shape: 'assets', flag: 'assets' }[picked.type] || 'text')
        : 'text';
      this.syncTools();
      /* Op mobiel NIET automatisch omhoog. Je eerste aanraking is meestal het
         begin van een sleepbeweging; het paneel schoof dan over je ontwerp
         terwijl je aan het schuiven was. Eén keer tikken selecteert, nog een
         keer tikken opent de instellingen. Zie onTap(). */
    }
    this.renderTab();
    this.renderLayers();
  };

  /* Fabric werkt in pixels; het model in millimeters. Hier vertalen we terug. */
  Editor.prototype.readBack = function (obj) {
    if (!obj || !obj.sckrId || this._trashHot) return;
    var item = this.find(obj.sckrId);
    if (!item) return;
    var s = this.scale;
    item.xMm = +(obj.left / s).toFixed(3);
    // yMm is de BOVENKANT van de tekst, net als in de printrenderer.
    // Fabric geeft het middelpunt, dus halen we de halve hoogte eraf.
    item.yMm = +((obj.top - obj.getScaledHeight() / 2) / s).toFixed(3);
    item.rotation = +(obj.angle || 0).toFixed(2);
    if (item.type === 'text') {
      item.sizeMm = +((obj.fontSize * (obj.scaleY || 1)) / s).toFixed(3);
      // widthMm bewust niet bewaren: de breedte volgt uit de tekst zelf.
      // Stond die er nog uit een ouder ontwerp, dan haalt de renderer hem weg.
      delete item.widthMm;
    } else {
      // Vormen en afbeeldingen hangen aan hun middelpunt; het model rekent
      // vanaf de linkerbovenhoek.
      item.widthMm = +(obj.getScaledWidth() / s).toFixed(3);
      item.heightMm = +(obj.getScaledHeight() / s).toFixed(3);
      item.xMm = +((obj.left - obj.getScaledWidth() / 2) / s).toFixed(3);
      item.yMm = +((obj.top - obj.getScaledHeight() / 2) / s).toFixed(3);
    }
    this.persist();
    // v3: verslepen, schalen en draaien zijn ook een stap terug (stond er niet in).
    this.pushHistory();
  };

  /* ------------------------------------------------------------ Gereedschap */

  /* Welke tab is actief. Op mobiel telt ook wat de lade toont: staan de lagen
     of het afronden open, dan is geen gereedschapstab geselecteerd. */
  Editor.prototype.syncTools = function () {
    var self = this;
    var panel = this.q('[data-sckrc-panel]');
    var open = panel.getAttribute('data-open') === 'true';
    var view = panel.getAttribute('data-view') || 'tools';
    var tools = this.root.querySelectorAll('[data-sckrc-tool]');
    Array.prototype.forEach.call(tools, function (b) {
      b.setAttribute('aria-selected', String(b.getAttribute('data-sckrc-tool') === self.state.tool &&
        !(open && view !== 'tools')));
    });
    var lt = this.q('[data-sckrc-layerstab]');
    if (lt) lt.setAttribute('aria-selected', String(open && view === 'layers'));
  };

  Editor.prototype.renderTab = function () {
    var box = this.q('[data-sckrc-tabs]');
    box.innerHTML = '';
    this.syncTools();

    /* Zonder gekoppeld product kan er niets besteld worden. Dat hoort niet pas
       te blijken als je op de knop drukt. */
    if (!this.product()) {
      var warn = el('div', 'sckrc__setupwarn');
      warn.appendChild(el('span', 'sckrc__emptytitle', 'Nog geen product gekoppeld'));
      warn.appendChild(el('p', 'sckrc__emptybody',
        'Ga in de theme editor naar deze sectie, open "Winkelwagen" en kies bij ' +
        '"Product — Core" en "Product — Carbon" het juiste product. Zonder dat kan ' +
        'een ontwerp niet in de winkelwagen.'));
      box.appendChild(warn);
    }
    if (this.state.tool === 'base') this.tabBase(box);
    else if (this.state.tool === 'text') this.tabText(box);
    else if (this.state.tool === 'upload') this.tabUpload(box);
    else this.tabAssets(box);
    var self = this;
    requestAnimationFrame(function () { self.syncSheet(); });
  };

  Editor.prototype.tabBase = function (box) {
    var self = this;
    var f = el('div', 'sckrc__field');
    f.appendChild(el('span', 'sckrc__label', tx('background')));

    var grid = el('div', 'sckrc__options');
    grid.setAttribute('data-cols', '2');
    BASES.forEach(function (b) {
      var btn = el('button', 'sckrc__opt');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('data-sckrc-base', b.value);
      btn.setAttribute('aria-checked', String(self.side().background.value === b.value));
      btn.appendChild(el('span', null, tx('base_' + b.id)));
      grid.appendChild(btn);
    });
    f.appendChild(grid);
    box.appendChild(f);

    var note = el('p', 'sckrc__note');
    note.textContent = self.side().background.value === '#ffffff'
      ? tx('white_note')
      : tx('base_soon');
    box.appendChild(note);
  };

  Editor.prototype.tabText = function (box) {
    var self = this;
    var item = this.state.selectedId ? this.find(this.state.selectedId) : null;

    var add = el('button', 'sckrc__btn');
    add.type = 'button';
    add.setAttribute('data-sckrc-addtext', '');
    add.textContent = tx('text_add');
    box.appendChild(add);

    if (!item || item.type !== 'text') {
      var empty = el('div', 'sckrc__empty');
      empty.appendChild(el('span', 'sckrc__emptytitle', tx('text_empty_title')));
      var p = el('p', 'sckrc__emptybody',
        tx('text_empty_body'));
      empty.appendChild(p);
      box.appendChild(empty);
        return;
    }

    var fText = el('div', 'sckrc__field');
    fText.appendChild(el('label', 'sckrc__label', tx('text')));
    var input = el('input', 'sckrc__input');
    input.type = 'text';
    input.value = item.text;
    input.maxLength = 24;
    input.setAttribute('data-sckrc-textvalue', '');
    fText.appendChild(input);
    box.appendChild(fText);

    var fFont = el('div', 'sckrc__field');
    fFont.appendChild(el('label', 'sckrc__label', tx('font')));
    var sel = el('select', 'sckrc__select');
    sel.setAttribute('data-sckrc-textfont', '');
    (this.geo.fontCategories || []).forEach(function (cat) {
      var inCat = (self.geo.fonts || []).filter(function (f) { return f.category === cat; });
      if (!inCat.length) return;
      var grp = document.createElement('optgroup');
      grp.label = tOr('cat_' + slug(cat), cat);
      inCat.forEach(function (f) {
        var o = el('option', null, f.label);
        o.value = f.id;
        // Het lettertype in de lijst zelf tonen, zodat je niet hoeft te raden.
        o.style.fontFamily = "'" + f.family + "', sans-serif";
        if (f.id === item.font) o.selected = true;
        grp.appendChild(o);
      });
      sel.appendChild(grp);
    });
    fFont.appendChild(sel);
    box.appendChild(fFont);

    var fCol = el('div', 'sckrc__field');
    fCol.appendChild(el('span', 'sckrc__label', tx('colour')));
    var sw = el('div', 'sckrc__swatches');
    PALETTE.forEach(function (c) {
      var b = el('button', 'sckrc__swatch');
      b.type = 'button';
      b.style.background = c;
      b.setAttribute('data-sckrc-textcolor', c);
      b.setAttribute('aria-label', tx('colour_named', { name: c }));
      b.setAttribute('aria-checked', String(item.fill === c));
      sw.appendChild(b);
    });
    fCol.appendChild(sw);
    box.appendChild(fCol);

    var maxSize = Math.round(this.tpl().shapeMm.w * 0.6);
    box.appendChild(this.slider('Grootte', 'textsize', item.sizeMm, 3, maxSize, 0.5, ' mm'));
    box.appendChild(this.slider('Letterafstand', 'textspacing', item.letterSpacingMm || 0, -0.5, 4, 0.1, ' mm'));

    var row = el('div', 'sckrc__row');
    var del = el('button', 'sckrc__btn sckrc__btn--danger');
    del.type = 'button';
    del.setAttribute('data-sckrc-delete', '');
    del.textContent = tx('delete');
    row.appendChild(del);
    box.appendChild(row);

  };

  Editor.prototype.slider = function (label, key, value, min, max, step, unit) {
    var f = el('div', 'sckrc__field');
    var head = el('div', 'sckrc__rangehead');
    head.appendChild(el('span', 'sckrc__label', label));
    head.appendChild(el('span', 'sckrc__rangeval', (Math.round(value * 10) / 10) + unit));
    f.appendChild(head);
    var r = el('input', 'sckrc__range');
    r.type = 'range';
    r.min = min; r.max = max; r.step = step;
    r.value = Math.min(max, Math.max(min, value));
    r.setAttribute('data-sckrc-' + key, '');
    f.appendChild(r);
    return f;
  };

  Editor.prototype.tabLayers = function (box) {
    var self = this;
    if (!this.side().elements.length) return;
    var f = el('div', 'sckrc__field');
    f.appendChild(el('span', 'sckrc__label', tx('layers')));
    var list = el('div', 'sckrc__layers');
    this.side().elements
      .slice()
      .sort(function (a, b) { return (b.z || 0) - (a.z || 0); })
      .forEach(function (item) {
        var row = el('button', 'sckrc__layerrow');
        row.type = 'button';
        row.setAttribute('data-sckrc-pick', item.id);
        row.setAttribute('aria-current', String(item.id === self.state.selectedId));
        row.textContent = item.type === 'text' ? item.text : item.type;
        list.appendChild(row);
      });
    f.appendChild(list);
    box.appendChild(f);
  };

  /* -------------------------------------------------------------- Vormen -- */

  Editor.prototype.tabAssets = function (box) {
    var self = this;
    var item = this.selected();

    (this.geo.shapeCategories || []).forEach(function (cat) {
      var inCat = (self.geo.shapes || []).filter(function (x) { return x.category === cat; });
      if (!inCat.length) return;
      var f = el('div', 'sckrc__field');
      f.appendChild(el('span', 'sckrc__label', tOr('cat_' + slug(cat), cat)));
      var grid = el('div', 'sckrc__shapes');
      inCat.forEach(function (sh) {
        var b = el('button', 'sckrc__shape');
        b.type = 'button';
        b.title = tOr('shape_' + slug(sh.id), sh.label);
        b.setAttribute('aria-label', b.title);
        b.setAttribute('data-sckrc-addshape', sh.id);
        b.innerHTML = '<svg viewBox="0 0 ' + (self.geo.shapeViewBox || 100) + ' ' +
          (self.geo.shapeViewBox || 100) + '" aria-hidden="true"><path d="' + sh.d + '"/></svg>';
        grid.appendChild(b);
      });
      f.appendChild(grid);
      box.appendChild(f);
    });

    box.appendChild(this.flagPicker());

    if (item && item.type === 'flag') {
      box.appendChild(this.slider('Grootte', 'objsize', item.widthMm, 8,
        Math.round(this.tpl().shapeMm.w), 0.5, ' mm'));
      box.appendChild(this.deleteRow());
    }

    if (item && item.type === 'shape') {
      box.appendChild(this.colourField(item));
      box.appendChild(this.slider('Grootte', 'objsize', item.widthMm, 5,
        Math.round(this.tpl().shapeMm.w), 0.5, ' mm'));
      box.appendChild(this.deleteRow());
    }

  };

  /* Vlaggenkiezer. 262 stuks tegelijk tonen is onwerkbaar en laadt veel te veel
     plaatjes, dus standaard de nationaliteiten die in het Nederlandse voetbal
     het meest gevraagd worden, en zoeken voor de rest. */
  Editor.prototype.flagPicker = function () {
    var self = this;
    var f = el('div', 'sckrc__field');
    f.appendChild(el('span', 'sckrc__label', tx('flags')));

    var search = el('input', 'sckrc__input');
    search.type = 'search';
    search.placeholder = tx('flag_search');
    search.setAttribute('data-sckrc-flagsearch', '');
    search.value = this.state.flagQuery || '';
    f.appendChild(search);

    var grid = el('div', 'sckrc__flags');
    grid.setAttribute('data-sckrc-flaggrid', '');
    f.appendChild(grid);

    var hint = el('p', 'sckrc__note');
    hint.setAttribute('data-sckrc-flaghint', '');
    f.appendChild(hint);

    this.fillFlags(grid, hint, this.state.flagQuery || '');
    return f;
  };

  Editor.prototype.fillFlags = function (grid, hint, query) {
    var self = this;
    var all = this.geo.flags || [];
    var q = query.trim().toLowerCase();
    var list;

    if (q) {
      list = all.filter(function (x) { return flagName(x).toLowerCase().indexOf(q) > -1; });
    } else {
      list = POPULAR.map(function (code) {
        return all.filter(function (x) { return x.code === code; })[0];
      }).filter(Boolean);
    }

    var shown = list.slice(0, 60);
    grid.innerHTML = '';
    shown.forEach(function (flag) {
      var b = el('button', 'sckrc__flag');
      b.type = 'button';
      b.title = flagName(flag);
      b.setAttribute('aria-label', b.title);
      b.setAttribute('data-sckrc-addflag', flag.code);
      var img = el('img');
      img.src = self.flagUrl(flag.code);
      img.alt = '';
      img.loading = 'lazy';
      b.appendChild(img);
      grid.appendChild(b);
    });

    if (!q) hint.textContent = tx('flag_hint_all', { count: all.length });
    else if (!shown.length) hint.textContent = tx('flag_none', { query: query });
    else if (list.length > shown.length) hint.textContent = tx('flag_many', { count: list.length });
    else hint.textContent = tx('flag_found', { count: list.length });
  };

  /* ------------------------------------------------------------- Uploaden -- */

  Editor.prototype.tabUpload = function (box) {
    var item = this.selected();
    var maxMb = parseInt(this.root.dataset.maxUploadMb, 10) || 10;

    var f = el('div', 'sckrc__field');
    f.appendChild(el('span', 'sckrc__label', tx('own_image')));

    var drop = el('label', 'sckrc__drop');
    drop.setAttribute('data-sckrc-drop', '');
    var input = el('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/webp';
    input.setAttribute('data-sckrc-file', '');
    drop.appendChild(input);
    drop.appendChild(el('span', 'sckrc__droptitle', tx('choose_file')));
    drop.appendChild(el('span', 'sckrc__dropsub', tx('file_types', { mb: maxMb })));
    f.appendChild(drop);
    box.appendChild(f);

    var status = el('div', 'sckrc__status');
    status.setAttribute('data-sckrc-uploadstatus', '');
    box.appendChild(status);

    if (item && item.type === 'image') {
      box.appendChild(this.slider('Grootte', 'objsize', item.widthMm, 5,
        Math.round(this.tpl().shapeMm.w), 0.5, ' mm'));

      // Scherpte op ware grootte. Onder 150 dpi wordt sublimatiedruk zichtbaar
      // korrelig, dus dat moet de klant weten vóór het bestellen.
      var dpi = Math.round(item.pxW / (item.widthMm / 25.4));
      var q = el('p', dpi < 150 ? 'sckrc__note sckrc__note--warn' : 'sckrc__note');
      q.textContent = dpi < 150
        ? tx('dpi_low', { dpi: dpi })
        : tx('dpi_ok', { dpi: dpi });
      box.appendChild(q);

      box.appendChild(this.deleteRow());
    } else {
      var e = el('div', 'sckrc__empty');
      e.appendChild(el('span', 'sckrc__emptytitle', tx('upload_empty_title')));
      e.appendChild(el('p', 'sckrc__emptybody',
        tx('upload_empty_body')));
      box.appendChild(e);
    }

  };

  /* ------------------------------------------------------- Gedeelde velden -- */

  Editor.prototype.selected = function () {
    return this.state.selectedId ? this.find(this.state.selectedId) : null;
  };

  Editor.prototype.colourField = function (item) {
    var f = el('div', 'sckrc__field');
    f.appendChild(el('span', 'sckrc__label', tx('colour')));
    var sw = el('div', 'sckrc__swatches');
    PALETTE.forEach(function (c) {
      var b = el('button', 'sckrc__swatch');
      b.type = 'button';
      b.style.background = c;
      b.setAttribute('data-sckrc-textcolor', c);
      b.setAttribute('aria-label', tx('colour_named', { name: c }));
      b.setAttribute('aria-checked', String(item.fill === c));
      sw.appendChild(b);
    });
    f.appendChild(sw);
    return f;
  };

  Editor.prototype.deleteRow = function () {
    var row = el('div', 'sckrc__row');
    var del = el('button', 'sckrc__btn sckrc__btn--danger');
    del.type = 'button';
    del.setAttribute('data-sckrc-delete', '');
    del.textContent = tx('delete');
    row.appendChild(del);
    return row;
  };

  /* --------------------------------------------------------------- Acties */

  Editor.prototype.addText = function () {
    var t = this.tpl();
    var mid = t.artboardMm.w / 2;
    var item = {
      id: uid(), type: 'text', z: this.side().elements.length + 1,
      text: 'NAAM', font: 'Anton', align: 'center',
      fill: readableOn(this.side().background.value),
      xMm: mid, yMm: t.artboardMm.h * 0.35,
      // Geen widthMm: de tekst bepaalt zijn eigen breedte uit lettergrootte.
      sizeMm: t.shapeMm.w * 0.16, rotation: 0
    };
    this.side().elements.push(item);
    this.state.selectedId = item.id;
    this.addToCanvas(item);
    var obj = this.byId(item.id);
    if (obj) this.canvas.setActiveObject(obj);
    this.canvas.requestRenderAll();
    this.renderTab();
    this.renderLayers();
    this.pushHistory();
    this.persist();
  };

  Editor.prototype.nextZ = function () {
    return this.side().elements.reduce(function (m, e) {
      return Math.max(m, e.z || 0);
    }, 0) + 1;
  };

  Editor.prototype.addShape = function (shapeId) {
    var t = this.tpl();
    var size = t.shapeMm.w * 0.3;
    var item = {
      id: uid(), type: 'shape', z: this.nextZ(), shapeId: shapeId,
      fill: readableOn(this.side().background.value),
      xMm: (t.artboardMm.w - size) / 2,
      yMm: t.artboardMm.h * 0.4 - size / 2,
      widthMm: size, heightMm: size, rotation: 0
    };
    this.side().elements.push(item);
    this.state.selectedId = item.id;
    this.addToCanvas(item);
    var obj = this.byId(item.id);
    if (obj) this.canvas.setActiveObject(obj);
    this.canvas.requestRenderAll();
    this.renderTab();
    this.persist();
  };

  /* -------------------------------------------------------------- Uploaden */

  Editor.prototype.addFlag = function (code) {
    var self = this;
    // Verhouding uit de vlag zelf halen in plaats van 4:3 aannemen.
    this.loadFlag(code).then(function (flag) {
      var t = self.tpl();
      var w = t.shapeMm.w * 0.4;
      var h = w / flag.aspect;
      var item = {
        id: uid(), type: 'flag', z: self.nextZ(), flagCode: code,
        xMm: (t.artboardMm.w - w) / 2,
        yMm: t.artboardMm.h * 0.32 - h / 2,
        widthMm: w, heightMm: h, rotation: 0
      };
      self.side().elements.push(item);
      self.state.selectedId = item.id;
      self.addToCanvas(item);
      self.renderTab();
      self.renderLayers();
      self.pushHistory();
      self.persist();
    }).catch(function (e) {
      self.status(e.message, 'error');
    });
  };

  Editor.prototype.status = function (text, kind) {
    var node = this.q('[data-sckrc-uploadstatus]');
    if (!node) return;
    node.textContent = text || '';
    node.setAttribute('data-kind', kind || '');
  };

  /* Verkleinde kopie voor het canvas en voor localStorage. Het origineel op
     volle resolutie blijft in Supabase staan en gaat naar het drukwerk — we
     hoeven dus nooit een groot bestand terug te lezen in de browser.
     PNG, niet JPEG: clublogo's hebben doorgaans een transparante achtergrond. */
  function makePreview(img, maxPx) {
    var scale = Math.min(1, maxPx / Math.max(img.naturalWidth, img.naturalHeight));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.naturalWidth * scale));
    c.height = Math.max(1, Math.round(img.naturalHeight * scale));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/png');
  }

  /* De breedste scheenbeschermer is 99,78 mm. Op 300 dpi is dat 1178 pixels,
     dus alles boven 2000 pixels wordt bij het drukken toch weggegooid. Groter
     bewaren kost alleen opslag. Een telefoonfoto van 6 MB wordt hiermee
     ongeveer 400 kB, zonder enig zichtbaar verschil op het product. */
  var MAX_UPLOAD_PX = 2000;

  /* Heeft de afbeelding doorzichtige delen? Bepaalt of we PNG of JPEG maken:
     clublogo's moeten transparant blijven, foto's zijn als JPEG veel kleiner.
     We bekijken elke vierde pixel — ruim genoeg om alfa te vinden. */
  function hasAlpha(ctx, w, h) {
    var d = ctx.getImageData(0, 0, w, h).data;
    for (var i = 3; i < d.length; i += 16) if (d[i] < 250) return true;
    return false;
  }

  /* Maakt een versie die groot genoeg is voor de druk en niet groter.
     Past het origineel al binnen de grens, dan laten we het ongemoeid: opnieuw
     coderen zou alleen kwaliteit kosten. */
  function prepareForPrint(img, file) {
    var longest = Math.max(img.naturalWidth, img.naturalHeight);

    /* Ook opnieuw coderen als het bestand groot is maar de afmeting meevalt:
       een foto die als PNG is opgeslagen kan megabytes kosten bij 1900 pixels.
       Alleen op afmeting kijken zou dat geval missen. */
    var teGroot = longest > MAX_UPLOAD_PX || file.size > 800 * 1024;
    if (!teGroot) {
      return Promise.resolve({ blob: file, pxW: img.naturalWidth, pxH: img.naturalHeight, resized: false });
    }

    var scale = Math.min(1, MAX_UPLOAD_PX / longest);
    var c = document.createElement('canvas');
    c.width = Math.round(img.naturalWidth * scale);
    c.height = Math.round(img.naturalHeight * scale);
    var ctx = c.getContext('2d');
    ctx.drawImage(img, 0, 0, c.width, c.height);

    var alpha = file.type === 'image/jpeg' ? false : hasAlpha(ctx, c.width, c.height);
    return new Promise(function (resolve) {
      c.toBlob(function (blob) {
        resolve({ blob: blob, pxW: c.width, pxH: c.height, resized: true });
      }, alpha ? 'image/png' : 'image/jpeg', alpha ? undefined : 0.9);
    });
  }

  /* Uploads lopen via de Edge Function `customizer`: die telt per IP-adres,
     kijkt naar de echte bytes en schrijft pas dan in de privébucket. Direct in
     de opslag schrijven met de publieke sleutel kan sinds 22-09-2026 niet meer. */
  Editor.prototype.fn = function (route, body, headers) {
    var base = (this.root.dataset.supabaseUrl || '').replace(/\/$/, '');
    var key = this.root.dataset.supabaseKey || '';
    if (!base || !key) {
      return Promise.reject(new Error('Supabase staat nog niet ingesteld in de theme editor.'));
    }
    var h = { apikey: key };
    Object.keys(headers || {}).forEach(function (k) { h[k] = headers[k]; });
    return fetch(base + '/functions/v1/customizer/' + route, { method: 'POST', headers: h, body: body })
      .catch(function () { throw new Error(tx('offline')); })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok) throw new Error(res.status === 429 ? tx('rate_limited') : tx('save_failed', { status: res.status }));
          return j;
        });
      });
  };

  Editor.prototype.upload = function (blob) {
    if (blob.size > 3 * 1048576) {
      return Promise.reject(new Error(tx('file_still_big')));
    }
    return this.fn('upload', blob, { 'Content-Type': blob.type || 'image/png' })
      .then(function (j) { return j.path; });
  };

  Editor.prototype.handleFile = function (file) {
    var self = this;
    if (!file) return;

    var maxMb = parseInt(this.root.dataset.maxUploadMb, 10) || 10;
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) {
      this.status(tx('file_type_bad'), 'error');
      return;
    }
    if (file.size > maxMb * 1048576) {
      this.status(tx('file_too_big', { size: (file.size / 1048576).toFixed(1), mb: maxMb }), 'error');
      return;
    }

    this.status(tx('uploading'), 'busy');

    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var preview = makePreview(img, 600);
      URL.revokeObjectURL(url);

      prepareForPrint(img, file).then(function (prepped) {
        var pxW = prepped.pxW, pxH = prepped.pxH;
        if (prepped.resized) {
          self.status(tx('resized', { w: pxW, h: pxH }), 'busy');
        }
        return self.upload(prepped.blob, file.name).then(function (storagePath) {
          return { storagePath: storagePath, pxW: pxW, pxH: pxH };
        });
      }).then(function (res) {
        var storagePath = res.storagePath, pxW = res.pxW, pxH = res.pxH;
        var t = self.tpl();
        var wMm = t.shapeMm.w * 0.45;
        var hMm = wMm * (pxH / pxW);

        var item = {
          id: uid(), type: 'image', z: self.nextZ(),
          storagePath: storagePath, preview: preview,
          pxW: pxW, pxH: pxH,
          xMm: (t.artboardMm.w - wMm) / 2,
          yMm: t.artboardMm.h * 0.4 - hMm / 2,
          widthMm: wMm, heightMm: hMm, rotation: 0
        };
        self.side().elements.push(item);
        self.state.selectedId = item.id;
        self.addToCanvas(item);
        self.renderTab();
        self.renderLayers();
        self.pushHistory();
        self.persist();
        self.status('', '');
      }).catch(function (err) {
        self.status(err.message, 'error');
      });
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      self.status(tx('image_unreadable'), 'error');
    };
    img.src = url;
  };

  /* ------------------------------------------------------- Voorbeeldplaatje */

  /* Zet de drie lagen (ondergrond, canvas, logo) samen tot één PNG — precies
     wat de klant ziet. Geen herberekening van het ontwerp, dus het kan niet
     afwijken van de editor.

     Let op: de SVG-lagen hebben alleen een viewBox. Bij het serialiseren moeten
     width en height er expliciet in, anders neemt de browser 300x150 aan.
     Zie LEARNINGS.md. */
  Editor.prototype.snapshot = function (maxPx) {
    var self = this;
    this.clearGuides();
    /* Bewust GEEN discardActiveObject(). Dat wierp je uit je element zodra de
       miniatuur na een sleepbeweging werd bijgewerkt, waarna het paneel
       terugviel naar "tekst toevoegen".
       In plaats daarvan gebruiken we hieronder toCanvasElement(): dat is de
       exportroute die Fabric zelf voor toBlob gebruikt en die uitsluitend de
       objecten tekent, dus zonder selectiekaders of handvatten. */
    this.canvas.requestRenderAll();

    var board = this.q('[data-sckrc-board]');
    var w = board.clientWidth, h = board.clientHeight;
    var scale = Math.min(1, (maxPx || 900) / Math.max(w, h));
    var out = document.createElement('canvas');
    out.width = Math.max(1, Math.round(w * scale));
    out.height = Math.max(1, Math.round(h * scale));
    var ctx = out.getContext('2d');

    function layerImage(node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('width', w);
      clone.setAttribute('height', h);
      var str = new XMLSerializer().serializeToString(clone);
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error(tx('preview_failed'))); };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(str);
      });
    }

    return layerImage(this.q('[data-sckrc-bg]'))
      .then(function (bg) {
        ctx.drawImage(bg, 0, 0, out.width, out.height);
        // Exportweergave: alleen de objecten, geen selectiekaders.
        // v3: alleen het bord zelf, niet de rand van CANVAS_PAD eromheen.
        ctx.drawImage(self.canvas.toCanvasElement(1, {
          left: self.CANVAS_PAD, top: self.CANVAS_PAD, width: w, height: h
        }), 0, 0, out.width, out.height);
        return layerImage(self.q('[data-sckrc-fg]'));
      })
      .then(function (fg) {
        ctx.drawImage(fg, 0, 0, out.width, out.height);
        // Het voorbeeld toont het product na het snijden: alles buiten de
        // contour eraf, dus ook de bleed en de sluier.
        var t = self.tpl();
        ctx.save();
        ctx.globalCompositeOperation = 'destination-in';
        ctx.scale(out.width / t.artboardMm.w, out.height / t.artboardMm.h);
        ctx.fill(new Path2D(t.contour));
        ctx.restore();
        return new Promise(function (resolve) { out.toBlob(resolve, 'image/png'); });
      });
  };

  /* ------------------------------------------------------------- Bewaren -- */

  Editor.prototype.rpc = function (name, body) {
    var base = (this.root.dataset.supabaseUrl || '').replace(/\/$/, '');
    var key = this.root.dataset.supabaseKey || '';
    if (!base || !key) return Promise.reject(new Error('Supabase staat nog niet ingesteld.'));
    return fetch(base + '/rest/v1/rpc/' + name, {
      method: 'POST',
      headers: { apikey: key, Authorization: 'Bearer ' + key, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {
      throw new Error(tx('offline'));
    }).then(function (res) {
      return res.text().then(function (body) {
        if (!res.ok) {
          // Limiet bereikt: de databasemelding is voor de klant geschreven.
          var msg = '';
          try {
            var j = JSON.parse(body);
            if (j.code === 'P0429') msg = tx('rate_limited');
            else if (/te groot/.test(j.message || '')) msg = tx('design_too_big');
          } catch (e) { /* geen JSON */ }
          throw new Error(msg || tx('save_failed', { status: res.status }));
        }
        return body ? JSON.parse(body) : null;
      });
    });
  };

  /* Voorbeeldkopieën van uploads in het ontwerp verkleinen tot 400 px WebP (of
     JPEG zonder transparantie). Ze dienen alleen om een gedeelde link te tonen;
     de druk gebruikt het origineel uit de opslag. Een PNG van 600 px kon
     honderden kB zijn en blies het ontwerp over de databasegrens. */
  function shrinkPreviews(design) {
    var items = [];
    Object.keys(design.sides || {}).forEach(function (k) {
      (design.sides[k].elements || []).forEach(function (e) {
        if (e.type === 'image' && e.preview && e.preview.length > 60000) items.push(e);
      });
    });
    return Promise.all(items.map(function (e) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          var scale = Math.min(1, 400 / Math.max(img.naturalWidth, img.naturalHeight));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(img.naturalWidth * scale));
          c.height = Math.max(1, Math.round(img.naturalHeight * scale));
          var ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0, c.width, c.height);
          var out = c.toDataURL('image/webp', 0.85);
          // Safari zonder WebP-encoder geeft PNG terug; dan JPEG als er geen
          // transparantie is, anders de kleinere PNG.
          if (out.indexOf('data:image/webp') !== 0) {
            out = hasAlpha(ctx, c.width, c.height) ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.85);
          }
          if (out.length < e.preview.length) e.preview = out;
          resolve();
        };
        img.onerror = function () { resolve(); };
        img.src = e.preview;
      });
    }));
  }

  /* Bewaart het ontwerp en het voorbeeldplaatje, en geeft de deelcode terug.
     Bestaat er al een code met bewerk-token, dan werken we die bij in plaats
     van elke keer een nieuw ontwerp aan te maken. Weigert de database dat
     (het ontwerp is vergrendeld omdat het al in een winkelwagen zit), dan
     wordt het een nieuw ontwerp: zo verandert een bestelling nooit achteraf.

     Volgorde: eerst het ontwerp, dan het voorbeeld. De functie accepteert een
     voorbeeld alleen voor een bestaand ontwerp met de juiste token. */
  Editor.prototype.saveDesign = function () {
    var self = this;
    // De voorbeeldkopieën van uploads blijven bewust in het ontwerp: een
    // gedeelde link (?d=CODE) heeft ze nodig om de afbeelding te tonen, want de
    // uploadbucket is privé. De database begrenst een ontwerp op 500 kB.
    var design = JSON.parse(JSON.stringify(self.state.design));
    // Bij "beide hetzelfde" is rechts een kopie van links; de renderer en
    // normalizeDesign vullen die zelf weer aan. Scheelt de helft.
    if (design.sameBothSides) delete design.sides.right;

    var create = function () {
      return self.rpc('create_design', {
        p_size: self.state.size, p_data: design,
        p_material: self.state.material,
        p_product_handle: self.root.dataset.productHandle || null
      }).then(function (rows) {
        var row = Array.isArray(rows) ? rows[0] : rows;
        if (!row || !row.short_code) throw new Error(tx('save_error'));
        self.state.saved = { code: row.short_code, token: row.edit_token };
        self.persist();
        return self.state.saved;
      });
    };

    var saved = self.state.saved;
    var step = shrinkPreviews(design).then(function () {
      if (JSON.stringify(design).length > 480000) {
        throw new Error(tx('design_too_big'));
      }
      return (saved && saved.code && saved.token)
      ? self.rpc('update_design', {
          p_short_code: saved.code, p_edit_token: saved.token,
          p_data: design, p_size: self.state.size, p_material: self.state.material
        }).then(function (okResult) { return okResult === true ? saved : create(); })
      : create();
    });

    return step.then(function (s) {
      return self.snapshot(900).then(function (blob) {
        return self.fn('preview', blob, {
          'Content-Type': 'image/png', 'x-sckr-code': s.code, 'x-sckr-token': s.token
        });
      }).then(function (j) {
        return { code: s.code, token: s.token, previewUrl: j.url };
      });
    });
  };

  /* Vergrendelt het ontwerp vlak voor het de winkelwagen in gaat. Daarna
     weigert de database elke wijziging; verder ontwerpen wordt een kopie. */
  Editor.prototype.lockDesign = function (saved) {
    return this.rpc('lock_design', { p_short_code: saved.code, p_edit_token: saved.token })
      .then(function (okResult) {
        if (okResult !== true) throw new Error(tx('lock_failed'));
        return saved;
      });
  };

  Editor.prototype.byId = function (id) {
    return this.canvas.getObjects().filter(function (o) { return o.sckrId === id; })[0] || null;
  };

  Editor.prototype.updateSelected = function (patch) {
    var item = this.find(this.state.selectedId);
    if (!item) return;
    Object.keys(patch).forEach(function (k) { item[k] = patch[k]; });
    var obj = this.byId(item.id);
    if (obj) {
      if ('text' in patch) obj.set('text', patch.text);
      if ('font' in patch) obj.set('fontFamily', familyOf(this.geo, patch.font));
      if ('fill' in patch) obj.set('fill', patch.fill);
      if ('sizeMm' in patch) obj.set({ fontSize: patch.sizeMm * this.scale, scaleY: 1, scaleX: 1 });
      if ('widthMm' in patch && item.type !== 'text') {
        var ratio = item.heightMm && item.widthMm
          ? item.heightMm / item.widthMm
          : obj.getScaledHeight() / obj.getScaledWidth();
        var wPx = patch.widthMm * this.scale;
        obj.set({ scaleX: wPx / obj.width, scaleY: (wPx * ratio) / obj.height });
        item.heightMm = +(patch.widthMm * ratio).toFixed(3);
      }
      // charSpacing rekent in duizendsten van een em, dus afhankelijk van de
      // lettergrootte. Bij elke groottewijziging opnieuw zetten.
      if ('sizeMm' in patch || 'letterSpacingMm' in patch) {
        obj.set('charSpacing', item.sizeMm ? ((item.letterSpacingMm || 0) / item.sizeMm) * 1000 : 0);
      }
      obj.setCoords();
      this.canvas.requestRenderAll();
    }
    this.pushHistorySoon();
    this.persist();
  };

  Editor.prototype.remove = function () {
    var id = this.state.selectedId;
    if (!id) return;
    var obj = this.byId(id);
    if (obj) this.canvas.remove(obj);
    this.side().elements = this.side().elements.filter(function (e) { return e.id !== id; });
    this.state.selectedId = null;
    this.canvas.discardActiveObject();
    this.canvas.requestRenderAll();
    this.renderTab();
    this.renderLayers();
    this.pushHistory();
    this.persist();
  };

  Editor.prototype.setBase = function (value) {
    this.side().background = { type: 'color', value: value };
    this.paint();
    this.renderTab();
    this.pushHistory();
    this.persist();
  };

  /* ------------------------------------------------------- Winkelwagen ---- */

  Editor.prototype.products = function () {
    if (this._products !== undefined) return this._products;
    var node = this.root.querySelector('[data-sckrc-products]');
    try { this._products = node ? JSON.parse(node.textContent) : null; }
    catch (e) { this._products = null; }
    return this._products;
  };

  /* Het product dat bij het gekozen materiaal hoort. */
  Editor.prototype.product = function () {
    var all = this.products();
    if (!all) return null;
    return all[this.state.material] || null;
  };

  function money(cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
      .format((cents || 0) / 100);
  }

  /* Kiest de Custom-variant voor een maat, en de gewone variant van dezelfde
     maat om de meerprijs uit af te leiden.

     Pure functie zonder DOM, zodat dit los te testen is — de winkelwagen mag
     niet stilletjes de verkeerde variant pakken.

     We matchen op de tekst van de variantopties in plaats van op vaste ids:
     dan kun je in de admin producten omzetten of varianten opnieuw aanmaken
     zonder dat hier iets aangepast hoeft te worden. */
  function pickVariant(variants, sizeLabel, customWord, material) {
    var word = String(customWord || 'Custom').trim().toLowerCase();
    // "12 cm" -> "12cm", zodat schrijfwijze met of zonder spatie allebei werkt.
    var key = String(sizeLabel || '').toLowerCase().replace(/\s+/g, '');
    var mat = String(material || '').trim().toLowerCase();

    function flat(v) { return (v.options || []).join(' ').toLowerCase(); }
    // Geen cijfer ervoor: "8cm" mag niet matchen in "18cm".
    function sizeMatches(v) {
      if (!key) return false;
      var f = flat(v).replace(/\s+/g, '');
      var i = f.indexOf(key);
      while (i > -1) {
        if (i === 0 || !/[0-9]/.test(f.charAt(i - 1))) return true;
        i = f.indexOf(key, i + 1);
      }
      return false;
    }
    function isCustom(v) { return flat(v).indexOf(word) > -1; }
    function hasWord(v, w) { return (v.options || []).some(function (o) { return String(o).toLowerCase() === w; }); }

    var sized = (variants || []).filter(sizeMatches);
    // Staat het materiaal als optie in het product (Mini: CORE/CARBON), dan
    // daarop filteren. Een los product per materiaal heeft die optie niet en
    // blijft zo werken.
    if (mat && sized.some(function (v) { return hasWord(v, mat); })) {
      sized = sized.filter(function (v) { return hasWord(v, mat); });
    }
    var custom = sized.filter(isCustom)[0] || null;
    var standard = sized.filter(function (v) { return !isCustom(v); })[0] || null;

    if (!sized.length) return { variant: null, standard: null, surcharge: 0, available: false, reason: 'geen-maat' };
    if (!custom) return { variant: null, standard: standard, surcharge: 0, available: false, reason: 'geen-custom' };

    return {
      variant: custom,
      standard: standard,
      surcharge: standard ? Math.max(0, custom.price - standard.price) : 0,
      available: !!custom.available,
      reason: null
    };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { pickVariant: pickVariant };

  Editor.prototype.matchVariant = function () {
    var p = this.product();
    if (!p || !p.variants || !p.variants.length) return null;

    var res = pickVariant(p.variants, this.tpl().label, this.root.dataset.customOption, this.state.material);
    var word = this.root.dataset.customOption || 'Custom';

    if (res.reason === 'geen-maat') {
      res.problem = 'Geen variant gevonden voor maat ' + this.tpl().label + ' bij ' + p.title + '.';
    } else if (res.reason === 'geen-custom') {
      res.problem = 'Geen uitvoering "' + word + '" gevonden voor maat ' + this.tpl().label + ' bij ' + p.title + '.';
    } else {
      res.problem = null;
    }
    return res;
  };

  Editor.prototype.addToCart = function () {
    var self = this;
    var btn = this.q('[data-sckrc-submit]');
    var p = this.product();

    if (!p) {
      this.toast('Er is nog geen product gekoppeld voor dit materiaal. Kies er een in de theme editor.', 'error');
      return;
    }
    var rights = this.q('[data-sckrc-rights]');
    if (rights && !rights.checked) {
      this.toast(tx('rights_missing'), 'error');
      rights.focus();
      rights.closest('.sckrc__rights').setAttribute('data-invalid', 'true');
      return;
    }
    var match = this.matchVariant();
    if (!match || match.problem) {
      // De precieze reden (match.problem) is voor de theme editor; de klant
      // krijgt een zin die hij kan gebruiken.
      if (window.Shopify && window.Shopify.designMode && match && match.problem) this.toast(match.problem, 'error');
      else this.toast(tx('no_match'), 'error');
      return;
    }
    if (!match.available) {
      this.toast(tx('not_in_stock', { product: p.title }), 'error');
      return;
    }

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = tx('busy');

    this.saveDesign().then(function (saved) {
      return self.lockDesign(saved);
    }).then(function (saved) {
      var matLabel = (MATERIALS.filter(function (m) { return m.id === self.state.material; })[0] || {}).label || '';
      // Zichtbare eigenschappen volgen de taal van de klant. De printapp leest
      // alleen de vaste sleutels met een underscore; die ziet de klant niet.
      var props = {};
      props[tx('prop_size')] = self.tpl().label;
      props[tx('prop_material')] = matLabel;
      props[tx('prop_code')] = saved.code;
      props._design_code = saved.code;
      props._preview_url = saved.previewUrl;
      props._size = self.state.size;
      props._material = self.state.material;
      // Bewijs dat de klant verklaarde het beeld te mogen gebruiken.
      props._rechten_bevestigd = new Date().toISOString();
      // Meerprijs zichtbaar bij de bestelregel. Het bedrag komt uit het verschil
      // tussen de Standaard- en de Custom-variant, dus het kan niet uit de pas
      // lopen met wat er in de admin staat.
      if (match.surcharge > 0) {
        props[tx('prop_surcharge')] = '+' + money(match.surcharge);
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: match.variant.id, quantity: 1, properties: props }] })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) {
          throw new Error(j.description || j.message || tx('add_failed'));
        });
        return res.json();
      });
    }).then(function () {
      // Het ontwerp in de winkelwagen is vergrendeld. Wie hierna verder
      // ontwerpt, maakt een nieuw ontwerp met een eigen code.
      self.state.saved = null;
      self.persist();
      btn.textContent = original;
      btn.disabled = false;
      if (self.root.dataset.afterAdd === 'stay') {
        self.toast(tx('added'), 'ok');
        document.dispatchEvent(new CustomEvent('sckrc:added'));
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      btn.textContent = original;
      btn.disabled = false;
      self.toast(err.message, 'error');
    });
  };

  /* ------------------------------------------------------------ Pillen -- */

  Editor.prototype.share = function () {
    var self = this;
    this.toast(tx('saving'), '');
    this.saveDesign().then(function (saved) {
      var url = window.location.origin + window.location.pathname + '?d=' + saved.code;
      var klaar = function (gelukt) {
        self.toast(gelukt ? tx('link_copied', { code: saved.code })
                          : tx('your_code', { code: saved.code }), 'ok');
      };
      if (navigator.share) {
        navigator.share({ title: tx('share_title'), url: url })
          .then(function () { self.toast(tx('shared'), 'ok'); })
          .catch(function () { self.copy(url, klaar); });
      } else {
        self.copy(url, klaar);
      }
    }).catch(function (e) { self.toast(e.message, 'error'); });
  };

  /* Kopieert naar het klembord en meldt terug of dat gelukt is. Buiten een
     beveiligde verbinding of zonder toestemming faalt dit stil, dus de
     aanroeper moet altijd een leesbaar alternatief tonen. */
  Editor.prototype.copy = function (text, done) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(function () { if (done) done(true); })
        .catch(function () { if (done) done(false); });
      return;
    }
    // Terugval voor oudere browsers.
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var gelukt = document.execCommand('copy');
      ta.remove();
      if (done) done(gelukt);
    } catch (e) {
      if (done) done(false);
    }
  };

  Editor.prototype.saveDraft = function () {
    var self = this;
    this.toast(tx('saving'), '');
    this.saveDesign().then(function (saved) {
      // Meteen kopiëren: een code uit een melding overtypen is op een telefoon
      // vrijwel onmogelijk en op desktop ook onhandig.
      self.copy(saved.code, function (gelukt) {
        self.toast(gelukt
          ? tx('saved_copied', { code: saved.code })
          : tx('saved_note', { code: saved.code }), 'ok');
      });
    }).catch(function (e) { self.toast(e.message, 'error'); });
  };

  /* PDF met alleen een JPEG erin. Een echte PDF-bibliotheek is ruim 300 kB
     voor deze ene knop; dit is een geldig bestand van ~60 regels.

     Pure functie zonder DOM, zodat de opbouw los te testen is — een PDF met
     verkeerde byte-posities opent nergens en dat merk je pas bij de klant. */
  function buildPdfFromJpeg(jpeg, pxW, pxH, ptW, ptH) {
    var enc = new TextEncoder();
    var chunks = [];
    var offsets = [];
    var len = 0;

    function put(x) {
      var b = typeof x === 'string' ? enc.encode(x) : x;
      chunks.push(b);
      len += b.length;
    }
    function obj(n, body, stream) {
      offsets[n] = len;
      put(n + ' 0 obj\n' + body + '\n');
      if (stream) { put('stream\n'); put(stream); put('\nendstream\n'); }
      put('endobj\n');
    }

    put('%PDF-1.4\n');
    obj(1, '<< /Type /Catalog /Pages 2 0 R >>');
    obj(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
    obj(3, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + ptW.toFixed(2) + ' ' + ptH.toFixed(2) +
           '] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>');
    obj(4, '<< /Type /XObject /Subtype /Image /Width ' + pxW + ' /Height ' + pxH +
           ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpeg.length + ' >>', jpeg);
    var content = 'q ' + ptW.toFixed(2) + ' 0 0 ' + ptH.toFixed(2) + ' 0 0 cm /Im0 Do Q';
    obj(5, '<< /Length ' + content.length + ' >>', enc.encode(content));

    var xref = len;
    var lines = ['xref', '0 6', '0000000000 65535 f '];
    for (var i = 1; i <= 5; i++) lines.push(String(offsets[i]).padStart(10, '0') + ' 00000 n ');
    put(lines.join('\n') + '\n');
    put('trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');

    var out = new Uint8Array(len);
    var at = 0;
    for (var c = 0; c < chunks.length; c++) { out.set(chunks[c], at); at += chunks[c].length; }
    return out;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Object.assign(module.exports || {}, { buildPdfFromJpeg: buildPdfFromJpeg });
  }

  Editor.prototype.downloadPdf = function () {
    var self = this;
    this.toast(tx('preview_making'), '');

    this.snapshot(1400).then(function (blob) {
      return createImageBitmap(blob);
    }).then(function (bmp) {
      var c = document.createElement('canvas');
      c.width = bmp.width;
      c.height = bmp.height;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(bmp, 0, 0);

      // Watermerk: dit is een voorbeeld, geen productiebestand.
      ctx.save();
      ctx.translate(c.width / 2, c.height / 2);
      ctx.rotate(-Math.PI / 6);
      ctx.font = '700 ' + Math.round(c.width * 0.075) + 'px Montserrat, system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(10,10,10,0.16)';
      for (var y = -c.height; y < c.height; y += Math.round(c.width * 0.22)) {
        ctx.fillText('VOORBEELD · SCKR', 0, y);
      }
      ctx.restore();

      return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.9); })
        .then(function (jpg) { return jpg.arrayBuffer(); })
        .then(function (buf) {
          // A4 in punten (72 per inch), zelfde verhouding als de opname.
          var ptW = 595.28, ptH = ptW * (c.height / c.width);
          var pdf = buildPdfFromJpeg(new Uint8Array(buf), c.width, c.height, ptW, ptH);
          var url = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }));
          var a = document.createElement('a');
          a.href = url;
          a.download = 'sckr-ontwerp-voorbeeld.pdf';
          a.rel = 'noopener';
          // Safari en enkele mobiele browsers negeren een klik op een anker dat
          // niet in de pagina staat; daarom even toevoegen en weer weghalen.
          document.body.appendChild(a);
          a.click();
          setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 4000);
          self.toast(tx('preview_done'), 'ok');
        });
    }).catch(function (e) {
      self.toast(tx('preview_error', { error: e.message }), 'error');
    });
  };

  Editor.prototype.toast = function (text, kind) {
    var node = this.q('[data-sckrc-toast]');
    if (!node) return;
    node.textContent = text;
    node.setAttribute('data-kind', kind || '');
    node.hidden = false;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { node.hidden = true; }, 6000);
  };

  /* ------------------------------------------------------------- Lagen ---
     Vast vak onderin, Photoshop-gewijs: je ziet je stapel terwijl je aan een
     element werkt. Bovenste regel is de bovenste laag. */

  var TYPE_ICON = { text: 'text', image: 'upload', shape: 'assets', flag: 'assets' };

  Editor.prototype.layerName = function (item) {
    if (item.type === 'text') return item.text || tx('layer_text');
    if (item.type === 'flag') {
      var f = (this.geo.flags || []).filter(function (x) { return x.code === item.flagCode; })[0];
      return f ? flagName(f) : tx('layer_flag');
    }
    if (item.type === 'shape') {
      var sh = (this.geo.shapes || []).filter(function (x) { return x.id === item.shapeId; })[0];
      return sh ? tOr('shape_' + slug(sh.id), sh.label) : tx('layer_shape');
    }
    return tx('layer_image');
  };

  Editor.prototype.renderLayers = function () {
    var self = this;
    var list = this.q('[data-sckrc-layerlist]');
    var count = this.q('[data-sckrc-layercount]');
    if (!list) return;

    var items = (this.side().elements || []).slice().sort(function (a, b) { return (b.z || 0) - (a.z || 0); });
    if (count) count.textContent = items.length;
    list.innerHTML = '';

    if (!items.length) {
      var leeg = el('p', 'sckrc__layerempty',
        tx('layers_empty'));
      list.appendChild(leeg);
      return;
    }

    items.forEach(function (item, i) {
      var row = el('div', 'sckrc__layerrow');
      row.setAttribute('data-current', String(item.id === self.state.selectedId));

      var pick = el('button', 'sckrc__layerpick');
      pick.type = 'button';
      pick.setAttribute('data-sckrc-pick', item.id);
      pick.innerHTML = iconSvg(TYPE_ICON[item.type] || 'assets');
      pick.appendChild(el('span', 'sckrc__layername', self.layerName(item)));
      row.appendChild(pick);

      [['up', i === 0, tx('layer_up')], ['down', i === items.length - 1, tx('layer_down')]].forEach(function (a) {
        var b = el('button', 'sckrc__layeract');
        b.type = 'button';
        b.title = a[2];
        b.setAttribute('aria-label', a[2] + ': ' + self.layerName(item));
        b.setAttribute('data-sckrc-move', a[0]);
        b.setAttribute('data-sckrc-id', item.id);
        b.disabled = a[1];
        b.innerHTML = iconSvg(a[0]);
        row.appendChild(b);
      });

      var del = el('button', 'sckrc__layeract sckrc__layeract--danger');
      del.type = 'button';
      del.title = tx('delete');
      del.setAttribute('aria-label', tx('delete_named', { name: self.layerName(item) }));
      del.setAttribute('data-sckrc-remove', item.id);
      del.innerHTML = iconSvg('trash');
      row.appendChild(del);

      list.appendChild(row);
    });
  };

  /* Laag een plek naar voren of naar achteren. We hernummeren daarna alles,
     zodat z altijd 1..n blijft en er geen gaten of dubbele waarden ontstaan. */
  Editor.prototype.moveLayer = function (id, dir) {
    var arr = (this.side().elements || []).slice().sort(function (a, b) { return (a.z || 0) - (b.z || 0); });
    var i = arr.findIndex(function (e) { return e.id === id; });
    if (i < 0) return;
    var j = dir === 'up' ? i + 1 : i - 1;
    if (j < 0 || j >= arr.length) return;
    var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    arr.forEach(function (e, n) { e.z = n + 1; });
    this.side().elements = arr;
    this.state.selectedId = id;
    this.pushHistory();
    this.paint();
    this.renderLayers();
    this.persist();
  };

  /* --------------------------------------------------- Links en rechts --- */

  Editor.prototype.renderSideThumbs = function () {
    var self = this;
    var wrap = this.q('[data-sckrc-sides]');
    if (!wrap) return;
    wrap.setAttribute('data-same', String(this.state.design.sameBothSides));
    // Het vinkje staat in de HTML standaard aan; na een concept, ongedaan
    // maken of een geopende code moet het de echte stand tonen.
    var same = this.q('[data-sckrc-same]');
    if (same) same.checked = !!this.state.design.sameBothSides;

    ['left', 'right'].forEach(function (k) {
      var btn = self.root.querySelector('[data-sckrc-side="' + k + '"]');
      if (!btn) return;
      btn.setAttribute('aria-pressed', String(self.state.side === k && !self.state.design.sameBothSides));
      btn.closest('.sckrc__side').classList.toggle('sckrc__side--right', k === 'right');
      var img = btn.querySelector('img');
      var src = self._thumbs && self._thumbs[self.state.design.sameBothSides ? 'left' : k];
      if (img && src) img.src = src;
    });
  };

  /* Miniatuur van de kant waar je nu aan werkt. Uitgesteld, want elke opname
     tekent de drie lagen opnieuw. */
  Editor.prototype.updateThumb = function () {
    var self = this;
    clearTimeout(this._thumbTimer);
    this._thumbTimer = setTimeout(function () {
      if (!self.canvas) return;
      self.snapshot(240).then(function (blob) {
        var reader = new FileReader();
        reader.onload = function () {
          self._thumbs = self._thumbs || {};
          self._thumbs[self.state.side] = reader.result;
          self.renderSideThumbs();
        };
        reader.readAsDataURL(blob);
      }).catch(function () { /* miniatuur is bijzaak */ });
    }, 400);
  };

  Editor.prototype.setSide = function (side) {
    if (this.state.design.sameBothSides || side === this.state.side) return;
    this.state.side = side;
    this.state.selectedId = null;
    this.paint();
    this.renderTab();
    this.renderLayers();
    this.renderSideThumbs();
  };

  Editor.prototype.setSame = function (same) {
    var d = this.state.design;
    if (same) {
      var rechts = (d.sides.right.elements || []).length;
      var anders = JSON.stringify(d.sides.right) !== JSON.stringify(d.sides.left);
      if (rechts && anders &&
          !window.confirm(tx('confirm_overwrite_right'))) {
        this.q('[data-sckrc-same]').checked = false;
        return;
      }
      d.sameBothSides = true;
      this.state.side = 'left';
    } else {
      d.sameBothSides = false;
      d.sides.right = clone(d.sides.left);
    }
    this.pushHistory();
    this.paint();
    this.renderTab();
    this.renderLayers();
    this.renderSideThumbs();
    this.persist();
  };

  /* view: 'tools', 'layers' of 'checkout'. Dicht = altijd terug naar tools,
     zodat de dichte lade alleen de tabbalk laat zien. */
  Editor.prototype.openSheet = function (open, view) {
    var panel = this.q('[data-sckrc-panel]');
    var scrim = this.q('[data-sckrc-scrim]');
    if (view) panel.setAttribute('data-view', view);
    else if (!open) panel.setAttribute('data-view', 'tools');
    panel.setAttribute('data-open', String(open));
    scrim.hidden = !open;
    scrim.setAttribute('data-show', String(open));
    this.toggleMenu(false);
    this.syncTools();
    this.syncSheet();
  };

  /* ------------------------------------------------------------- Bindingen */

  Editor.prototype.bind = function () {
    var self = this;
    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () { self.paint(); }, 60);
    }
    var ro = new ResizeObserver(schedule);
    ro.observe(this.q('[data-sckrc-board]'));
    this.ro = ro;

    window.addEventListener('resize', function () { self.syncSheet(); self.syncTop(); });

    /* Greep bovenaan de lade: omlaag vegen of tikken sluit hem. */
    var grab = this.q('[data-sckrc-grab]');
    if (grab) {
      var y0 = null;
      grab.addEventListener('pointerdown', function (e) {
        y0 = e.clientY;
        try { grab.setPointerCapture(e.pointerId); } catch (err) { /* oude browsers */ }
      });
      grab.addEventListener('pointerup', function (e) {
        if (y0 !== null && e.clientY - y0 > -8) self.openSheet(false);
        y0 = null;
      });
      grab.addEventListener('pointercancel', function () { y0 = null; });
    }

    this.root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var menu = self.q('[data-sckrc-menu]');
      if (menu && !menu.hidden) { self.toggleMenu(false); var mb = self.q('[data-sckrc-more]'); if (mb) mb.focus(); return; }
      if (self.q('[data-sckrc-panel]').getAttribute('data-open') === 'true') self.openSheet(false);
    });
  };

  /* ---------------------------------------------------- Gedelegeerde events */

  function editorFor(node) {
    var root = node.closest('[data-sckrc]');
    return root ? instances.get(root) : null;
  }

  document.addEventListener('click', function (ev) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sckrc-menu]:not([hidden])'), function (m) {
      if (m.contains(ev.target) || ev.target.closest('[data-sckrc-more]')) return;
      var em = editorFor(m);
      if (em) em.toggleMenu(false);
    });
    var t = ev.target.closest('button');
    if (!t) {
      var scrim = ev.target.closest('[data-sckrc-scrim]');
      if (scrim) { var e0 = editorFor(scrim); if (e0) e0.openSheet(false); }
      return;
    }
    var ed = editorFor(t);
    if (!ed) return;

    /* ----------------------------------------------- Mobiel (v3) ------- */
    if (t.hasAttribute('data-sckrc-more')) { ed.toggleMenu(); return; }
    // Een menu-item doet zijn gewone actie hieronder; het menu gaat eerst dicht.
    if (t.closest('[data-sckrc-menu]')) ed.toggleMenu(false);
    if (t.hasAttribute('data-sckrc-checkout')) { ed.openSheet(true, 'checkout'); return; }
    if (t.hasAttribute('data-sckrc-closesheet')) { ed.openSheet(false); return; }
    if (t.hasAttribute('data-sckrc-layerstab')) {
      var lp = ed.q('[data-sckrc-panel]');
      var toont = lp.getAttribute('data-open') === 'true' && lp.getAttribute('data-view') === 'layers';
      ed.openSheet(!toont, toont ? null : 'layers');
      return;
    }

    var size = t.getAttribute('data-sckrc-size');
    if (size) {
      ed.state.size = size;
      if (ed.state.material && !ed.isAvailable(size, ed.state.material)) ed.preferAvailable(true);
      ed.buildSetup();
      ed.q('[data-sckrc-step-material]').hidden = false;
      ed.q('[data-sckrc-board]').hidden = false;
      // Direct laten zien wat je kiest; doorgaan doe je zelf met bevestigen.
      ed.renderBoard();
      ed.syncSheet();
      ed.persist();
      return;
    }

    var mat = t.getAttribute('data-sckrc-material');
    if (mat) {
      ed.state.material = mat;
      ed.buildSetup();
      ed.syncSheet();
      ed.persist();
      return;
    }

    if (t.hasAttribute('data-sckrc-codego')) { ed.openByCode(); return; }

    if (t.hasAttribute('data-sckrc-confirm')) {
      if (ed.state.size && ed.state.material) ed.enterWork();
      return;
    }

    var edit = t.getAttribute('data-sckrc-edit');
    if (edit) { ed.showSetup(); return; }

    var tool = t.getAttribute('data-sckrc-tool');
    if (tool) {
      var tp = ed.q('[data-sckrc-panel]');
      var toontTool = tp.getAttribute('data-open') === 'true' && (tp.getAttribute('data-view') || 'tools') === 'tools';
      if (ed.state.tool === tool && toontTool && window.matchMedia('(max-width: 1023px)').matches) {
        ed.openSheet(false);
      } else {
        ed.state.tool = tool;
        ed.renderTab();
        if (window.matchMedia('(max-width: 1023px)').matches) ed.openSheet(true, 'tools');
      }
      return;
    }

    if (t.hasAttribute('data-sckrc-submit')) { ed.addToCart(); return; }

    /* ------------------------------------------------- Rail en lagen ---- */

    var zoom = t.getAttribute('data-sckrc-zoom');
    if (zoom) { ed.zoomBy(zoom); return; }

    if (t.hasAttribute('data-sckrc-undo')) { ed.undo(); return; }
    if (t.hasAttribute('data-sckrc-redo')) { ed.redo(); return; }
    if (t.hasAttribute('data-sckrc-reset')) { ed.resetAll(); return; }

    var side = t.getAttribute('data-sckrc-side');
    if (side) { ed.setSide(side); return; }

    if (t.hasAttribute('data-sckrc-layers-toggle')) {
      var panel = ed.q('[data-sckrc-layerpanel]');
      var dicht = panel.getAttribute('data-collapsed') === 'true';
      panel.setAttribute('data-collapsed', String(!dicht));
      t.setAttribute('aria-expanded', String(dicht));
      // Op mobiel wisselt dit tussen gereedschap en lagen in dezelfde sheet.
      if (window.matchMedia('(max-width: 1023px)').matches) {
        ed.q('[data-sckrc-panel]').setAttribute('data-view', dicht ? 'layers' : 'tools');
        ed.openSheet(true);
      }
      return;
    }

    var move = t.getAttribute('data-sckrc-move');
    if (move) { ed.moveLayer(t.getAttribute('data-sckrc-id'), move); return; }

    var rm = t.getAttribute('data-sckrc-remove');
    if (rm) { ed.state.selectedId = rm; ed.remove(); return; }

    /* ------------------------------------------------------- Pillen ----- */

    if (t.hasAttribute('data-sckrc-share')) { ed.share(); return; }
    if (t.hasAttribute('data-sckrc-savedraft')) { ed.saveDraft(); return; }
    if (t.hasAttribute('data-sckrc-pdf')) { ed.downloadPdf(); return; }

    if (t.hasAttribute('data-sckrc-addtext')) { ed.addText(); return; }

    var shapeId = t.getAttribute('data-sckrc-addshape');
    if (shapeId) { ed.addShape(shapeId); return; }

    var flagCode = t.getAttribute('data-sckrc-addflag');
    if (flagCode) { ed.addFlag(flagCode); return; }
    if (t.hasAttribute('data-sckrc-delete')) { ed.remove(); return; }

    var base = t.getAttribute('data-sckrc-base');
    if (base) { ed.setBase(base); return; }

    var colour = t.getAttribute('data-sckrc-textcolor');
    if (colour) { ed.updateSelected({ fill: colour }); ed.renderTab(); return; }

    var pick = t.getAttribute('data-sckrc-pick');
    if (pick) {
      var obj = ed.byId(pick);
      if (obj) { ed.canvas.setActiveObject(obj); ed.canvas.requestRenderAll(); }
      ed.state.selectedId = pick;
      ed.renderTab();
      ed.renderLayers();
      if (window.matchMedia('(max-width: 1023px)').matches) ed.openSheet(true, 'tools');
      return;
    }
  });

  document.addEventListener('input', function (ev) {
    var ed = editorFor(ev.target);
    if (!ed) return;
    var t = ev.target;

    if (t.hasAttribute('data-sckrc-flagsearch')) {
      ed.state.flagQuery = t.value;
      var grid = ed.q('[data-sckrc-flaggrid]');
      var hint = ed.q('[data-sckrc-flaghint]');
      if (grid && hint) ed.fillFlags(grid, hint, t.value);
      return;
    }

    if (t.hasAttribute('data-sckrc-textvalue')) {
      ed.updateSelected({ text: t.value || ' ' });
      return;
    }

    /* Bij schuiven alleen de waarde en het canvas bijwerken, niet het hele
       paneel opnieuw opbouwen — dan verlies je de greep op de regelaar. */
    function label(node, text) {
      var head = node.parentNode.querySelector('.sckrc__rangeval');
      if (head) head.textContent = text;
    }

    if (t.hasAttribute('data-sckrc-textsize')) {
      var size = parseFloat(t.value);
      ed.updateSelected({ sizeMm: size });
      label(t, (Math.round(size * 10) / 10) + ' mm');
      return;
    }

    if (t.hasAttribute('data-sckrc-objsize')) {
      var w = parseFloat(t.value);
      ed.updateSelected({ widthMm: w });
      label(t, (Math.round(w * 10) / 10) + ' mm');
      return;
    }

    if (t.hasAttribute('data-sckrc-textspacing')) {
      var sp = parseFloat(t.value);
      ed.updateSelected({ letterSpacingMm: sp });
      label(t, (Math.round(sp * 10) / 10) + ' mm');
      return;
    }
  });

  document.addEventListener('change', function (ev) {
    var ed = editorFor(ev.target);
    if (!ed) return;
    if (ev.target.hasAttribute('data-sckrc-textfont')) {
      ed.updateSelected({ font: ev.target.value });
      return;
    }
    if (ev.target.hasAttribute('data-sckrc-same')) {
      ed.setSame(ev.target.checked);
      return;
    }
    if (ev.target.hasAttribute('data-sckrc-file')) {
      ed.handleFile(ev.target.files && ev.target.files[0]);
      ev.target.value = '';   // zelfde bestand opnieuw kiezen moet ook werken
    }
  });

  /* ------------------------------------------------------------------ Start */

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sckrc]');

    /* Twee customizers op een pagina delen hun concept in localStorage en hun
       toetsenbordbediening; dat levert een onbegrijpelijke wirwar op. Alleen
       de eerste starten en duidelijk melden wat er aan de hand is. */
    var alAanwezig = document.querySelectorAll('[data-sckrc]').length;
    if (alAanwezig > 1) {
      console.warn('[SCKR] Er staan ' + alAanwezig + ' customizer-secties op deze pagina. ' +
        'Alleen de eerste wordt gestart. Haal de andere weg in de theme editor.');
    }

    Array.prototype.forEach.call(roots, function (root, i) {
      if (alAanwezig > 1 && document.querySelector('[data-sckrc]') !== root) {
        root.setAttribute('data-sckrc-disabled', 'true');
        return;
      }
      if (instances.has(root)) return;
      if (!window.SCKR_GEOMETRY || !window.fabric) return;
      loadFonts(window.SCKR_GEOMETRY);
      instances.set(root, new Editor(root));
    });
  }

  function ready() {
    // Fabric en de geometrie laden met defer; wachten tot beide er zijn.
    if (!window.SCKR_GEOMETRY || !window.fabric) { setTimeout(ready, 30); return; }
    boot(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
})();
